package org.multiplatform.kotfolio.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("ktor")
@Composable
fun KTORPage() {
    BlogLayout(
        PageProperties(
            "KTOR",
            "KTOR is a multiplatform Asynchronous HTTP client which uses different plugins to extend its functionalities. To free up the space for threads and coroutines call."),
        BlogProperties("API Calling", "KTOR")
    ) {
        Column(horizontalAlignment = Alignment.Start)
        {
            Ul {
                Li {
                    SpanText(
                        text = "Ktor is a multiplatform Asynchronous HTTP client which uses different plugins to extend its functionalities. To free up the space for threads and coroutines call.",
                        modifier = Modifier.padding(topBottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }

                Li {
                    SpanText(
                        text = "Ktor Client is a part of the Ktor framework, which is designed to simplify the process of making HTTP requests in Kotlin-based applications. It provides an asynchronous and non-blocking way to interact with web services, making it a perfect choice for modern, highly concurrent applications. Whether you are developing a mobile app, web app, or backend service, Ktor Client can be a valuable tool in your Kotlin toolbox.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }

                Li {
                    SpanText(
                        text = "We first build an HTTP client and then add plugins to it. That forms the basis of Ktor.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }

                Li {
                    SpanText(
                        text = "Depending on our platform we decide the engine for the Ktor like Android, IOS, Linux, windows etc.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }

                Li {
                    SpanText(
                        text = "We can use different Engines based on where we are using KTOR like Android, JVM, curl etc.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }

                Li {
                    SpanText(
                        text = "Flexibility and Extensibility – Easily customize engines and protocols like HTTP/2 and WebSockets.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }

                Li {
                    SpanText(
                        text = "Native JSON Support with Kotlin Serialization – Seamless, lightweight, and Kotlin-first.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }

                Li {
                    SpanText(
                        text = "Built-in Streaming and WebSocket Support – Ideal for real-time and streaming data handling. Better Handling for Non-REST APIs – Suitable for GraphQL, SOAP, or custom APIs.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            KotlinCode(
                code = """
                    ktor = "3.4.2"
                    
                    [libraries]
                    ktor-client-content-negotiation = { group = "io.ktor", name = "ktor-client-content-negotiation", version.ref = "ktor" }
                    ktor-client-core = { group = "io.ktor", name = "ktor-client-core", version.ref = "ktor" }
                    ktor-client-darwin = { group = "io.ktor", name = "ktor-client-darwin", version.ref = "ktor" }
                    ktor-client-okhttp = { group = "io.ktor", name = "ktor-client-okhttp", version.ref = "ktor" }
                    ktor-client-serialization-json = { group = "io.ktor", name = "ktor-serialization-kotlinx-json", version.ref = "ktor" }
                    ktor-client-logging = { group = "io.ktor", name = "ktor-client-logging", version.ref = "ktor" }
                    ktor-client-auth = { module = "io.ktor:ktor-client-auth", version.ref = "ktor" }
                    
                    jetbrains-lifecycle-viewmodel = { module = "org.jetbrains.androidx.lifecycle:lifecycle-viewmodel", version.ref = "lifecycle" }
                    jetbrains-lifecycle-runtime-compose = { module = "org.jetbrains.androidx.lifecycle:lifecycle-runtime-compose", version.ref = "lifecycle" }

                    [plugins]
                    kotlin-serialization = { id = "org.jetbrains.kotlin.plugin.serialization", version.ref = "kotlin" }

                    [bundles]
                    ktor = [
                        "ktor-client-content-negotiation",
                        "ktor-client-core",
                        "ktor-client-serialization-json",
                        "ktor-client-logging"
                        "ktor-client-auth",
                    ]
                    
                    lifecycle = [
                        "jetbrains-lifecycle-viewmodel",
                        "jetbrains-lifecycle-runtime-compose"
                    ]
                    
                    sourceSets {
                        commonMain.dependencies {
                            implementation(libs.bundles.ktor)
                        }
                    }    
                    """.trimIndent()
            )


            SpanText(
                text = "Ktor Plugin System",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Ktor uses a plugin architecture instead of OkHttp’s interceptor chain. Each plugin can modify requests before they’re sent and responses after they’re received:",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            KotlinCode(
                code = """
                    Request flow:
                    Your code → DefaultRequest → Auth → Logging → Engine → Network
                    
                    Response flow:
                    Network → Engine → Logging → ContentNegotiation → Your code
                    """.trimIndent()
            )

            SpanText(
                text = "ktor-client-core",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "ktor-client-core contains core Ktor client functionality.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In commonMain, you add the core client ktor-client-core, the content-negotiation plugin, JSON serialization, and logging, which form the foundation of the network layer. Then, for each target platform, you specify its own engine.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Gradle will automatically select the correct implementation during the build. Android uses OkHttp, iOS and other Apple platforms use the native Darwin engine, JVM uses CIO (Coroutine-based I/O), and the browser uses the Js engine, which works on top of the Fetch API.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Engine dependency",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Ktor is a Kotlin framework for building HTTP clients and servers. On the client side, Ktor does not perform the network transport itself. Instead it delegates to a component called an engine, which opens a TCP connection, sends the bytes, and reads the response. You choose the engine when you create your HttpClient.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Engines are used to process network requests. Note that a specific platform may require a specific engine that processes network requests.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Plugins are used to extend the client with a specific functionality.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "These are the three types of dependencies that you might need while using Ktor.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If you want to configure the engine you are using then you can do that in this way.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We can install different plugins inside our HttpClient to extend our functionalities.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Three of these engines",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "CIO: Ktor’s own engine, written in Kotlin, is available on almost every Kotlin target.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "OkHttp: A mature HTTP library from Square that is the de facto standard on Android. Ktor provides a wrapper around it.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Darwin: AKtor engine for Apple platforms (iOS, macOS, tvOS, watchOS). It wraps NSURLSession, which is Apple's system-level HTTP API.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }


            SpanText(
                text = "HttpClient",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
               Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "HttpClient to do a network call → It is a base class that allows us to configure our network requests. If you call the HttpClient without any argument the Ktor will choose the engine automatically.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "HttpClient function. The first parameter of this function takes an engine. In this case, we are on Android, so pass `Android` as an engine. As I previously mentioned, you need to add dependencies on a specific platform for the engine. The next parameter is userConfig. It is a lambda to configure it in this block.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "CIO",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "CIO stands for “Coroutine-based I/O”. The Ktor FAQ describes it as a fully asynchronous, coroutine-based engine that implements HTTP using Kotlin and coroutines, without relying on external JVM-based HTTP libraries. In practical terms, this means that CIO is not a wrapper around OkHttp, NSURLSession, or libcurl.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When you call HttpClient(CIO), you are using Ktor's own HTTP implementation from top to bottom..",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            //https://github.com/dsqrwym/HomeChat.git
            KotlinCode(
                code = """
                    expect object HttpClientProvider {
                        val client: HttpClient
                    }
                    
                    internal fun HttpClientConfig<*>.installCommonPlugins() {
                        // JSON serialization; ignore unknown fields to be forward-compatible
                        install(ContentNegotiation) {
                            json(Json {
                                ignoreUnknownKeys = true 
                                explicitNulls = false 
                                encodeDefaults = true 
                        }
                        // Timeouts to avoid hanging requests
                        install(HttpTimeout) {
                            connectTimeoutMillis = ApiConfig.CONNECT_TIMEOUT_MILLIS
                            requestTimeoutMillis = ApiConfig.REQUEST_TIMEOUT_MILLIS
                        }
                        if (ApiConfig.ENABLE_LOGGING) {
                            install(Logging) { level = LogLevel.ALL }
                        }
                        install(WebSockets)
                    }
                    
                    actual object HttpClientProvider {
                        actual val client: HttpClient by lazy {
                            HttpClient { installCommonPlugins() }
                        }
                    }
                    
                    //webMain
                    actual object HttpClientProvider {
                        @OptIn(ExperimentalWasmJsInterop::class)
                        actual val client: HttpClient by lazy {
                            HttpClient(Js) {
                                installCommonPlugins()
                            }
                        }
                    }
                    
                    //jvmMain
                    actual object HttpClientProvider {
                        actual val client: HttpClient by lazy {
                            HttpClient(CIO) { installCommonPlugins() }
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "HttpClient(Android)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "HttpClient(Android) creates a Ktor HttpClient using the Android-specific engine. Android uses OkHttp, a popular HTTP client that is reliable, efficient, and optimized for mobile.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It is a part of Ktor’s client-side libraries, which allow developers to make network requests and interact with APIs",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This engine is optimized to work with Android's networking stack.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            //https://github.com/beHqo/MockStore
            KotlinCode(
                code = """
                    //1 HttpClient with Dispatchers
                    object HttpClientFactory {
                        fun create(): HttpClient = HttpClient(createHttpEngine()) {
                            engine { dispatcher = Dispatchers.IO }
                        }
                    }
                    
                    //2 getHttpClientEngine()
                    HttpClient(engine = getHttpClientEngine()) {}
                    
                    //3 Darwin
                    val client = HttpClient(Darwin) {
                        engine { // this: DarwinClientEngineConfig }
                    }

                    actual fun getClientEngine(): HttpClientEngine = Darwin.create()
                    """.trimIndent()
            )

            SpanText(
                text = "Ktor with Darwin Engine for iOS",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A Kotlin/Native client engine that targets Darwin-based operating systems (such as macOS, iOS, tvOS, and so on) and uses NSURLSession internally. To configure the engine, pass the settings exposed by DarwinClientEngineConfig to the engine method.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            //https://github.com/Grippo-app/grippo-mobile.git
            KotlinCode(
                code = $$"""
                    @Single
                    internal class BackendClient(
                        httpClient: HttpClient,
                        tokenProvider: TokenProvider,
                        clientLogger: ClientLogger,
                        json: Json,
                    ) {
                        private val clientProvider = httpClient.config {
                            install(HttpTimeout) {
                                requestTimeoutMillis = 10_000
                                connectTimeoutMillis = 10_000
                                socketTimeoutMillis = 10_000
                            }

                            install(Logging) {
                                level = LogLevel.ALL
                                logger = clientLogger
                            }

                            install(Auth) {
                                providers.add(tokenProvider)
                            }

                            install(ContentNegotiation) {
                                json(
                                    json = json,
                                    contentType = ContentType.Application.Json
                                )
                            }

                            defaultRequest {
                                host = ""
                                port = 8080
                                url { protocol = URLProtocol.HTTPS }
                                contentType(ContentType.Application.Json)
                                header(HttpHeaders.AcceptLanguage, AppLocale.current())
                            }
                        }

                        suspend fun invoke(
                            method: HttpMethod,
                            path: String,
                            body: Any? = null,
                            queryParams: Map<String, String>? = null
                        ): HttpResponse {
                            return withContext(Dispatchers.IO) {
                                clientProvider.request {
                                    url {
                                        path(path)
                                        queryParams?.forEach { (key, value) -> parameters.append(key, value) }
                                        body?.let { setBody(body) }
                                    }
                                    this.method = method
                                }
                            }
                        }
                    }
                    
                    @Single
                    public class GrippoApi internal constructor(private val client: BackendClient) {
                        /* * * * * * * * * * * * * * * * *
                         * Utilities
                         * * * * * * * * * * * * * * * * */

                        private suspend inline fun <reified T> request(
                            method: HttpMethod,
                            path: String,
                            body: Any? = null,
                            queryParams: Map<String, String>? = null
                        ): Result<T> {
                            return runCatching {
                                client.invoke(
                                    method = method,
                                    path = path,
                                    body = body,
                                    queryParams = queryParams
                                ).body()
                            }
                        }
                        
                        /* * * * * * * * * * * * * * * * *
                         * Auth service
                         * * * * * * * * * * * * * * * * */

                        public suspend fun login(body: EmailAuthBody): Result<TokenResponse> {
                            return request(
                                method = HttpMethod.Post,
                                path = "/auth/login",
                                body = body
                            )
                        }
                    }
                    
                    internal fun HttpClientConfig<*>.responseValidatorresponseValidator(
                        apiErrorParser: ApiErrorParser
                    ) = HttpResponseValidator {
                        validateResponse { response ->
                            val statusCode = response.status.value

                            if (statusCode in 200..299) return@validateResponse

                            val rawBody = runCatching { response.bodyAsText() }.getOrNull()

                            when (statusCode) {
                                in 400..499 -> {
                                    val parsed = apiErrorParser.parseDetailedMessage(rawBody, statusCode)
                                    throw AppError.Network.Expected(
                                        keys = apiErrorParser.parseKeys(rawBody),
                                        title = parsed.title,
                                        description = parsed.description
                                    )
                                }

                                in 500..599 -> {
                                    throw AppError.Network.Unexpected(
                                        message = apiErrorParser.getDefaultServerErrorMessage(statusCode)
                                    )
                                }

                                else -> throw AppError.Network.Unexpected(
                                    message = "Unexpected HTTP code: $statusCode"
                                )
                            }
                        }

                        handleResponseExceptionWithRequest { cause, _ ->
                            when (cause) {
                                is AppError.Network.Expected -> throw cause

                                is TimeoutCancellationException,
                                is HttpRequestTimeoutException -> throw AppError.Network.Timeout(
                                    message = "Request timed out. Try again.",
                                    cause = cause
                                )

                                is JsonConvertException -> throw AppError.Network.Unexpected(
                                    message = "Invalid server response format.",
                                    cause = cause
                                )

                                is IOException -> throw AppError.Network.NoInternet(
                                    message = "Connection lost or unavailable.",
                                    cause = cause
                                )

                                else -> AppError.Network.Unexpected(
                                    message = cause.message ?: "Unexpected network error",
                                    cause = cause
                                )
                            }
                        }
                    }
                    
                    //commonMain
                    public expect class NativeContext
                    
                    internal expect fun NativeContext.driver(): HttpClient
                    
                    //iosMain
                    internal actual fun NativeContext.driver(): HttpClient {
                        return HttpClient(Darwin) { engine { configureRequest { setAllowsCellularAccess(true) } } }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Type-safe requests",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Type-safe requests refer to an approach in HTTP request handling that leverages a strongly-typed programming language (such as Kotlin) to define the structure of requests and responses. ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In the context of mobile applications, this means that the data types (e.g., JSON, XML) are explicitly defined and validated at compile time, reducing the risk of errors.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "ktor-client-resources",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Module within the Ktor framework that provides a type-safe way to define and manage Restful API endpoints. ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This module enables you to define API routes as Kotlin classes, where each class represents a resource or endpoint in your API. The parameters of the route (such as query parameters or path segments) are modeled as properties of the class.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "ktor-client-content-negotiation",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When building apps, communication with the server is key. Whether you're fetching user data or posting updates, ensuring smooth and correct data exchange is crucial. Content negotiation ensures that the data format from the server matches what your app expects, while logging gives you visibility into what's happening under the hood.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The module enables automatic content negotiation, meaning it can automatically handle the conversion of data between different formats (like JSON or XML) based on the Content-Type of the response or the Accept header of the request.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This module integrates with popular serialization libraries such as kotlinx.serialization, Jackson, and Gson. This allows for seamless serialization of Kotlin data classes to JSON or other formats and vice versa.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The JSON configuration is set to be lenient, allowing it to handle unexpected or missing keys without throwing errors. The explicitNulls = false option ensures that the absence of null values in the JSON doesn’t cause issues during parsing.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "ktor-client-logging",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The module allows you to log various parts of HTTP requests and responses, including headers, bodies, and status codes. ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This helps in understanding the flow of data and diagnosing issues. This module integrates well with existing logging systems like SLF4J, Logback. On Android, JetBrains recommend to use the SLF4J Android library.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Install ContentNegotiation",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "install(ContentNegotiation) { ... } installs the ContentNegotiation feature, which allows the client to automatically serialize and deserialize data to and from JSON format.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "json(Json { ignoreUnknownKeys = true }) specifies that the kotlinx.serialization library should be used for JSON handling. The ignoreUnknownKeys = true configuration tells the serializer to ignore any unknown keys in the JSON response, which is useful when dealing with APIs that may include extra fields not present in your data models.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Ghost Serializer - (Ktor JSON Parsing 66% Faster with 50% Less Memory on KMP)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Ghost Serializer—a byte-first JSON serializer designed for KMP, and the official HTTP Arena benchmarks just went live showing some wild improvements when integrated with Ktor.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = " Ghost doesn't find its @GhostSerializable annotation on a class, it will return null and let Ktor fallback to your standard serializer. This means you can adopt Ghost incrementally, using it only on your highest-traffic endpoints!",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            KotlinCode(
                code = """
                    //https://github.com/juanchurtado1991/ghost-serializer
                    
                    import io.ktor.server.application.*
                    import io.ktor.server.plugins.contentnegotiation.*
                    import com.ghost.serialization.ktor.ghost
                    import kotlinx.serialization.json.Json

                    fun Application.module() {
                        install(ContentNegotiation) {
                            // 1. Ghost handles high-performance @GhostSerializable endpoints
                            ghost() 
                            // 2. Kotlinx.serialization (or Jackson/Gson) handles the rest as fallback
                            json(Json { ignoreUnknownKeys = true })
                        }
                    }
                    
                    // Processed by GHOST (High Performance)
                    @GhostSerializable
                    data class HighTrafficUser(val id: Long, val email: String)
                    """.trimIndent()
            )

            SpanText(
                text = "Install Resources",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "install(Resources) enables the use of type-safe API endpoints using the ktor-client-resources module. This feature allows you to define API routes as Kotlin classes or objects, making your HTTP interactions more type-safe and structured.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Install Logging",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "install(Logging) adds logging capabilities to the HttpClient. This will log the details of HTTP requests and responses, which is helpful for debugging and monitoring network interactions.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            Link(
                path = "https://start.ktor.io/settings",
                text = "Create KTOR Project",
                modifier = Modifier
                    .margin(right = 4.px)
            )

            SpanText(
                text = "Koin module create",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/Shayne3000/Donezo
            //https://github.com/Let-s-build-something/client-app.git
            //https://github.com/Vovvser/vowser-client.git
            KotlinCode(
                code = """
                    /**
                     * Koin module for networking dependencies
                     */
                    val networkingModule = module {
                        // declare Kotlinx.json JSON serializer
                        single<Json> {
                            Json {
                                ignoreUnknownKeys = true  // Ignore extra fields sent by the backend
                                isLenient = true  // Accepts malformed JSON JSON (e.g. unquoted keys)
                                encodeDefaults = true // Force sending default properties in POST/PUT requests
                                useArrayPolymorphism = true
                                useAlternativeNames = false
                                coerceInputValues = true  // Fallback to default values defined in your data class if the key is missing
                                encodeDefaults = true
                                explicitNulls = false // Strict null payload checking for maximum type safety
                                allowSpecialFloatingPointValues = true
                                allowStructuredMapKeys = true
                                prettyPrint = true // Formats the raw string printout for your Logging plugin
                                namingStrategy = JsonNamingStrategy.SnakeCase
                                classDiscriminator = "#class"
                                
                                serializersModule = createEventSerializersModule(
                                    DefaultEventContentSerializerMappings
                                ).overwriteWith(DefaultLocalSerializerMappings)
                                
                                /*
                                serializersModule = SerializersModule {
                                    polymorphic(WebSocketMessage::class) {
                                        subclass(WebSocketMessage.AllPathsWrapper::class)
                                    }
                                }
                                
                                @Serializable
                                sealed interface WebSocketMessage {
                                    @Serializable
                                    @SerialName("all_navigation_paths")
                                    data class AllPathsWrapper(val data: AllPathsResponse) : WebSocketMessage 
                                }
                                
                                @Serializable
                                data class AllPathsResponse(
                                    val query: String,
                                    val paths: List<PathDetail>
                                )

                                @Serializable
                                data class PathDetail(
                                    val pathId: String,
                                    val score: Double?,
                                    val total_weight: Int?,
                                    val last_used: String? = null,
                                    val estimated_time: Double? = null,
                                    val steps: List<NavigationStep>
                                )
                                */
                            }
                        }

                        // declare ktor client instance
                        single<HttpClient> {
                            // Not supplying an engine will allow the client to select during compile time,
                            // the engine appropriate for the specific target platform
                            // based on the supplied engine dependencies for each target in the build config file.
                            HttpClient {
                                install(ContentNegotiation) {
                                    // register kotlinx.json as the ktorClient's JSON serializer
                                    json(json = get<Json>(), contentType = ContentType.Application.Json)
                                }
                                install(Logging) {
                                    logger = Logger.DEFAULT
                                    level = if (isDebugBuild()) LogLevel.BODY else LogLevel.NONE
                                    sanitizeHeader { header -> header == HttpHeaders.Authorization }
                                }
                            }
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "createClientPlugin",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/nyuksoonvong3432/kmp-todoist-app
            KotlinCode(
                code = $$"""
                    import io.ktor.client.plugins.api.createClientPlugin

                    class AuthHeaderPluginConfig {
                        var accessTokenType: String = ""
                        var accessToken: String = ""
                    }

                    val AuthHeaderPlugin = createClientPlugin("AuthHeaderPlugin", ::AuthHeaderPluginConfig) {
                        val accessTokenType = pluginConfig.accessTokenType
                        val accessToken = pluginConfig.accessToken
                        onRequest { request, content ->
                            if (accessToken.isNotEmpty() && accessTokenType.isNotEmpty()) {
                                val token = "$accessTokenType $accessToken"
                                request.headers.append("Authorization", token)
                            }
                        }
                    }
                    
                    class APIClient(val authentication: Authentication) {
                        val baseUrl: Url = Url(urlString = "")

                        val httpClient = HttpClient {
                            install(Logging) {
                                logger = Logger.DEFAULT
                                level = LogLevel.ALL
                            }
                            install(ContentNegotiation) {
                                json(Json {
                                    ignoreUnknownKeys = true
                                    useAlternativeNames = false
                                })
                            }
                            install(AuthHeaderPlugin) {
                                if (authentication.accessTokenType != null && authentication.accessToken != null) {
                                    accessTokenType = authentication.accessTokenType!!
                                    accessToken = authentication.accessToken!!
                                }
                            }
                        }

                        suspend inline fun <reified Body, reified Result> post(baseUrl: Url? = null, path: String, body: Body? = null): Result {
                            val response = httpClient.post("${baseUrl ?: this.baseUrl}$path") {
                                contentType(ContentType.Application.Json)
                                setBody(body)
                            }
                            if (!response.status.isSuccess()) {
                                val errorBody = response.bodyAsText()
                                throw Exception("HTTP ${response.status.value}: $errorBody")
                            }
                            return response.body()
                        }

                        suspend inline fun <reified Result> get(baseUrl: Url? = null, path: String, parameters: Parameters? = null): Result {
                            val response = httpClient.get("${baseUrl ?: this.baseUrl}$path") {
                                contentType(ContentType.Application.Json)
                                parameters?.forEach { key, values ->
                                    values.forEach { value ->
                                        parameter(key, value)
                                    }
                                }
                            }
                            if (!response.status.isSuccess()) {
                                val errorBody = response.bodyAsText()
                                throw Exception("HTTP ${response.status.value}: $errorBody")
                            }
                            return response.body()
                        }
                    }
                    
                    class Authentication {
                        private val baseOAuthUrl = ""
                        private val clientID = ""

                        var accessToken: String? = null
                            private set
                        var accessTokenType: String? = null
                            private set

                        suspend fun tryRestoreAccess() {
                            loadTokenFromCache()
                            if (accessToken == null || accessTokenType == null) {
                                throw Exception("No token found.")
                            }
                        }

                        fun getAuthorizationUrl(): Url {
                            return Url("$baseOAuthUrl/authorize?client_id=$clientID&scope=data:delete,data:read_write&state=asdasndakj")
                        }

                        suspend fun authenticate(clientSecret: String, code: String, redirectUrlPath: String) {
                            val httpClient = HttpClient() {
                                install(Logging) {
                                    logger = Logger.DEFAULT
                                    level = LogLevel.HEADERS
                                }
                                install(ContentNegotiation) {
                                    json(Json {
                                        ignoreUnknownKeys = true
                                        useAlternativeNames = false
                                    })
                                }
                            }
                            val result: AuthAuthenticatedResponseDTO =
                                httpClient.post(urlString = "$baseOAuthUrl/access_token") {
                                    contentType(ContentType.Application.Json)
                                    setBody(
                                        AuthAuthenticatePayloadDTO(
                                            clientID = clientID,
                                            clientSecret = clientSecret,
                                            code = code,
                                            redirectUrlPath
                                        )
                                    )
                                }.body()
                            this.accessToken = result.accessToken
                            this.accessTokenType = result.tokenType
                            saveTokenInCache("${result.tokenType} ${result.accessToken}")
                        }

                        suspend fun logout() {
                            clearTokenFromCache()
                            this.accessToken = null
                            this.accessTokenType = null
                        }

                        private suspend fun saveTokenInCache(token: String) {
                            getCacheContainer().write(CacheContainerKey.ACCESS_TOKEN, token)
                        }

                        private suspend fun loadTokenFromCache() {
                            val result: String = getCacheContainer().read(CacheContainerKey.ACCESS_TOKEN)
                                ?: return

                            val splitted = result.split(" ")
                            val tokenType = splitted.getOrNull(0)
                            val token = splitted.getOrNull(1)
                            if (tokenType != null && token != null) {
                                this.accessToken = token
                                this.accessTokenType = tokenType
                            }
                        }

                        private suspend fun clearTokenFromCache() {
                            getCacheContainer().remove(CacheContainerKey.ACCESS_TOKEN)
                        }
                    }
                    
                    interface CacheContainer {
                        suspend fun <T> write(key: CacheContainerKey, data: T)
                        suspend fun <T> read(key: CacheContainerKey): T?
                        suspend fun remove(key: CacheContainerKey)
                    }

                    enum class CacheContainerKey {
                        ACCESS_TOKEN {
                            override fun toString(): String {
                                return "access_token"
                            }
                        }
                    }

                    expect fun getCacheContainer(): CacheContainer
                    
                    //iosMain
                    import platform.Foundation.NSUserDefaults
                    import platform.Foundation.setValue
                    import platform.Foundation.valueForKey

                    class IOSCacheContainer: CacheContainer {
                        override suspend fun <T> write(key: CacheContainerKey, data: T) {
                            NSUserDefaults.standardUserDefaults().setValue(data, key.toString())
                        }

                        override suspend fun <T> read(key: CacheContainerKey): T? {
                            return (NSUserDefaults.standardUserDefaults().valueForKey(key.toString()) as? T)
                        }

                        override suspend fun remove(key: CacheContainerKey) {
                            NSUserDefaults.standardUserDefaults().removeObjectForKey(key.toString())
                        }
                    }

                    actual fun getCacheContainer(): CacheContainer = IOSCacheContainer()
                    
                    //androidMain
                    
                    class AndroidCacheContainer: CacheContainer {
                        override suspend fun <T> write(key: CacheContainerKey, data: T) {
                           
                        }

                        override suspend fun <T> read(key: CacheContainerKey): T? {
                           
                        }

                        override suspend fun remove(key: CacheContainerKey) {
                           
                        }
                    }

                    actual fun getCacheContainer(): CacheContainer = AndroidCacheContainer()
                    """.trimIndent()
            )

            //https://github.com/mccostic/NBRideMultiPlatform.git
            KotlinCode(
                code = """
                    class KtorClientFactory(private val host: String, private val tokens: TokenRepository) {
                        fun create(): HttpClient = HttpClient(engine()) {
                            expectSuccess = true

                            install(DefaultRequest) { }

                            install(ContentNegotiation) { }
                            
                            install(HttpRedirect) {
                                checkHttpMethod = true // Default is true
                                allowHttpsDowngrade = false // Default is false, equivalent to followSslRedirects=true
                            }

                            install(Logging) {
                                logger = object : Logger { override fun log(message: String) { Log.d(message, "Ktor") } }
                                level = LogLevel.ALL
                            }

                            install(Auth) {
                                bearer {
                                    loadTokens {
                                        val access = tokens.access()
                                        val refresh = tokens.refresh()
                                        access?.let { BearerTokens(it, refresh ?: "") }
                                    }
                                    sendWithoutRequest { req -> req.url.host == host }
                                    refreshTokens { null } // wire refresh later
                                }
                            }
                        }
                    }

                    expect fun engine(): HttpClientEngineFactory<*>
                    
                    //di
                    val coreModule = module {
                        single { KtorClientFactory(host = "", tokens = get()).create() }
                    }
                    
                    //iosMain
                    import io.ktor.client.engine.*
                    import io.ktor.client.engine.darwin.*

                    actual fun engine(): HttpClientEngineFactory<*> = Darwin
                    
                    //androidMain
                    import io.ktor.client.engine.*
                    import io.ktor.client.engine.okhttp.*

                    actual fun engine(): HttpClientEngineFactory<*> = OkHttp
                    """.trimIndent()
            )

            SpanText(
                text = "ContentNegotiation Dynamic Convert",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    HttpClient {
                        install(ContentNegotiation) {
                            // register kotlinx.json as the ktorClient's JSON serializer
                            json(json = get<Json>(), contentType = ContentType.Application.Json)
                        }
                    }
                    """.trimIndent()
            )

            //https://github.com/gangoogle/first_kotlin_multiplatform
            KotlinCode(
                code = $$"""
                    install(ContentNegotiation) {
                        register(ContentType.Application.Json, AutoUnwrapKotlinxConverter())
                    }
                    
                    import io.ktor.util.reflect.TypeInfo
                    import io.ktor.utils.io.core.*
                    import io.ktor.http.*
                    import io.ktor.http.content.OutgoingContent
                    import io.ktor.http.content.TextContent
                    import io.ktor.serialization.ContentConverter
                    import io.ktor.utils.io.*
                    import io.ktor.utils.io.charsets.Charset
                    import kotlinx.serialization.json.*
                    import kotlinx.serialization.*
                    import kotlinx.serialization.serializer  

                    class AutoUnwrapKotlinxConverter(
                        private val json: Json = Json { ignoreUnknownKeys = true; prettyPrint = true }
                    ) : ContentConverter {

                        override suspend fun serialize(
                            contentType: ContentType,
                            charset: Charset,
                            typeInfo: TypeInfo,
                            value: Any?
                        ): OutgoingContent? {
                            if (value == null) return null
                            //KType
                            val serializer = json.serializersModule.serializer(typeInfo.kotlinType!!)
                            val text = json.encodeToString(serializer as KSerializer<Any>, value)
                            return TextContent(text, contentType.withCharset(charset))
                        }

                        override suspend fun deserialize(
                            charset: Charset,
                            typeInfo: TypeInfo,
                            content: ByteReadChannel
                        ): Any? {
                            val text = content.readRemaining().readText(charset = charset)
                            val element = json.parseToJsonElement(text)

                            if (element !is JsonObject) {
                                val deserializer = json.serializersModule.serializer(typeInfo.kotlinType!!)
                                return json.decodeFromJsonElement(deserializer, element)
                            }
                            val jsonObject = element
                            val (codeKey, dataKey, msgKey, successCode) = when {
                                "StatusCode" in jsonObject -> listOf("StatusCode", "Data", "Errors", "200")
                                "resCode" in jsonObject -> listOf("resCode", "data", "resMsg", "200")
                                "code" in jsonObject -> listOf("code", "data", "message", "200")
                                "errorCode" in jsonObject -> listOf("errorCode", "data", "errorMsg", "0")
                                else -> throw ResponseException("Exception: $text")
                            }
                            println("code: $codeKey, data: $dataKey, msg: $msgKey, successCode: $successCode")
                           
                            val code = jsonObject[codeKey]?.jsonPrimitive?.content ?: "-1"
                            if (code != successCode) {
                                val msg = jsonObject[msgKey]?.jsonPrimitive?.content ?: "未知错误"
                                throw ResponseException("Exception: $msg (code=$code)")
                            }

                            if (dataKey !in jsonObject) return true

                            val dataElement = jsonObject[dataKey]!!
                            if (typeInfo.type == String::class) {
                                return dataElement.toString()
                            }
                            val deserializer = json.serializersModule.serializer(typeInfo.kotlinType!!)
                            return json.decodeFromJsonElement(deserializer, dataElement)
                        }
                    }

                    class ResponseException(message: String) : RuntimeException(message)
                    """.trimIndent()
            )

            //https://github.com/gangoogle/first_kotlin_multiplatform
            /*
            KotlinCode(
                code = """
                    object KtorClient {
                        lateinit var client: HttpClient

                        fun init() {
                            client = HttpClient() {
                                defaultRequest {
                                    url.takeFrom(UrlConfig.baseUrl)
                                    header("WarehouseCode", "YDSHA")
                                }
                                install(ContentNegotiation) {
                                    register(ContentType.Application.Json, AutoUnwrapKotlinxConverter())
                                }

                            }
                        }
                    }

                    object UrlConfig {
                        val baseUrl = "https://www.wanandroid.com//"
                        val hotKey = "hotkey/json"
                    }

                    object ApiServer {

                        inline fun <reified T> ktorGet(
                            path: String,
                            noinline block: suspend () -> T = {
                                KtorClient.client.get(path).body<T>()
                            }
                        ): suspend () -> Deferred<T> = {
                            CoroutineScope(Dispatchers.IO).async { block() }
                        }

                        inline fun <reified T> ktorPost(
                            path: String,
                            requestBody: Any,
                            noinline block: suspend () -> T = {
                                KtorClient.client.post {
                                    url.takeFrom(path)
                                    setBody(requestBody)
                                }.body<T>()
                            }
                        ): suspend () -> Deferred<T> = {
                            CoroutineScope(Dispatchers.IO).async { block() }
                        }
                        suspend fun getTestUrl() = ktorGet<List<TopWords>>(UrlConfig.hotKey)()
                    }

                    fun CoroutineScope.startRequestScope(
                        request: suspend CoroutineScope.() -> Unit,
                        onFinish: (error:Throwable?) -> Unit = {},
                    ) {
                        var throwable: Throwable? = null
                        this.launch(Dispatchers.IO) {
                            try {
                                request.invoke(this)
                            } catch (e: Throwable) {
                                throwable = e
                            } finally {
                                withContext(Dispatchers.Main) {
                                    onFinish.invoke(throwable)
                                }
                            }
                        }
                    }

                    fun requestHotKey() {
                        screenModelScope.startRequestScope(request = {
                            val hotKey = ApiServer.getTestUrl().await()

                        }, onFinish = { error ->
                            hideLoading()
                            error?.let {
                                println("onError:" + it.message)
                            }
                        })
                    }
                    """.trimIndent()
            )*/

            SpanText(
                text = "KtorClient Factory",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    object KtorClientFactory {
                        fun create(): HttpClient {
                            return HttpClient {
                                
                            }
                        }
                    }

                    class NetworkService {
                        val httpClient = KtorClientFactory.create()

                        companion object {
                            val INSTANCE: NetworkService by lazy(SYNCHRONIZED) { NetworkService() }
                        }
                    }

                    //Access ViewModel
                    class LoginViewModel: ViewModel() {
                        internal val networkService by lazy { NetworkService.INSTANCE }
                    }
                    """.trimIndent()
            )

            //https://github.com/thejohnsondev/PassGuard-Multiplatform.git
            KotlinCode(
                code = """
                    import io.ktor.client.HttpClient

                    expect object HttpClientProvider {
                        fun provide(): HttpClient
                    }
                    
                    //nativeMain
                    import io.ktor.client.HttpClient
                    import io.ktor.client.engine.darwin.Darwin

                    actual object HttpClientProvider {
                        actual fun provide(): HttpClient = HttpClient(Darwin) {
                            engine {
                                configureRequest {
                                    setTimeoutInterval(NetworkEngineConfig.default.connectTimeout.toDouble())
                                }
                            }
                        }
                    }
                    
                    //desktopMain
                    import io.ktor.client.HttpClient
                    import io.ktor.client.engine.apache5.Apache5

                    actual object HttpClientProvider {
                        actual fun provide(): HttpClient = HttpClient(Apache5) {
                            engine {
                                followRedirects = NetworkEngineConfig.default.followRedirects
                                connectTimeout = NetworkEngineConfig.default.connectTimeout
                                connectionRequestTimeout = NetworkEngineConfig.default.connectionRequestTimeout
                            }
                        }
                    }
                    
                    //androidMain
                    import io.ktor.client.HttpClient
                    import io.ktor.client.engine.okhttp.OkHttp
                    import java.time.Duration

                    actual object HttpClientProvider {
                        actual fun provide(): HttpClient = HttpClient(OkHttp) {
                            engine {
                                config {
                                    followRedirects(NetworkEngineConfig.default.followRedirects)
                                    connectTimeout(Duration.ofMillis(NetworkEngineConfig.default.connectTimeout))
                                    readTimeout(Duration.ofMillis(NetworkEngineConfig.default.connectionRequestTimeout))
                                }
                            }
                        }
                    }
                    
                    val networkModule = module {
                        single {
                            val client = HttpClientProvider.provide().config {
                                install(ContentNegotiation) {
                                    json(Json {
                                        prettyPrint = true
                                        isLenient = true
                                        ignoreUnknownKeys = true
                                    })
                                }
                                install(Logging) {
                                    logger = Logger.SIMPLE
                                    level = LogLevel.ALL
                                }
                            }
                            client.plugin(HttpSend).intercept { request ->
                                if (getPlatform() == Platform.IOS_SIMULATOR) {
                                    return@intercept execute(request)
                                }
                                val isInternetConnected = Konnection.instance.isConnected()
                                if (!isInternetConnected) throw NoInternetConnectionException()
                                execute(request)
                            }
                            client
                        }

                        single {
                            Konnection.instance
                        }
                        single {
                            CoroutineScope(Dispatchers.IO)
                        }
                    }
                    """.trimIndent()
            )

            //https://github.com/shaka-it/kmp-multimodule-sample
            KotlinCode(
                code = """
                    //commonMain
                    internal expect class HttpEngineFactory constructor() {
                        fun createEngine(): HttpClientEngineFactory<HttpClientEngineConfig>
                    }
                    
                    //androidMain
                    internal actual class HttpEngineFactory {
                        actual fun createEngine(): HttpClientEngineFactory<HttpClientEngineConfig> = Android
                    }
                    
                    //iosMain
                    internal actual class HttpEngineFactory {
                        actual fun createEngine(): HttpClientEngineFactory<HttpClientEngineConfig> = Darwin
                    }
                    
                    //desktop
                    internal actual class HttpEngineFactory {
                        actual fun createEngine(): HttpClientEngineFactory<HttpClientEngineConfig> = OkHttp
                    }
                    
                    //wasm
                    internal actual class HttpEngineFactory {
                        actual fun createEngine(): HttpClientEngineFactory<HttpClientEngineConfig> = Js
                    }
                    
                    internal val ktorModule = module {
                        single {
                            HttpClient(HttpEngineFactory().createEngine()) {
                                install(Logging) {
                                    logger = Logger.SIMPLE
                                    level = LogLevel.ALL
                                }

                                install(DefaultRequest)

                                install(ContentNegotiation) {
                                    json(Json {
                                        isLenient = true
                                        ignoreUnknownKeys = true
                                        prettyPrint = true
                                    })
                                }

                                install(HttpTimeout) {
                                    connectTimeoutMillis = 15000
                                    requestTimeoutMillis = 30000
                                }

                                defaultRequest {
                                    url("")
                                    header("Content-Type", "application/json; charset=UTF-8")
                                }
                            }
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Network Speed Check",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/Let-s-build-something/client-app.git
            KotlinCode(
                code = """
                    import io.ktor.client.request.HttpResponseData
                    import io.ktor.client.statement.HttpResponse
                    import io.ktor.client.statement.bodyAsBytes
                    import io.ktor.http.contentLength
                    import io.ktor.utils.io.core.toByteArray
                    import kotlinx.coroutines.Dispatchers
                    import kotlinx.coroutines.IO
                    import kotlinx.coroutines.withContext

                    enum class NetworkSpeed {
                        VerySlow,
                        Slow,
                        Moderate,
                        Good,
                        Fast
                    }

                    suspend fun HttpResponse.speedInMbps(): Double {
                        return withContext(Dispatchers.IO) {
                            val contentSize = (contentLength().takeIf { it != 0L } ?: bodyAsBytes().size.toLong()) * 2 // optimism about the speed
                            if(contentSize < 400_000) return@withContext 0.0
                            val secondsTaken = (responseTime.timestamp - requestTime.timestamp) / 1_000.0

                            withContext(Dispatchers.Default) {
                                if (contentSize > 0 && secondsTaken > 0) {
                                    val speedBps = contentSize / secondsTaken // bps
                                    speedBps / 1_000_000.0 // Mbps
                                } else 0.0
                            }
                        }
                    }

                    suspend fun HttpResponseData.speedInMbps(): Double {
                        return withContext(Dispatchers.IO) {
                            val contentSize = (this@speedInMbps.body.toString().toByteArray().size.toLong()) * 2 // optimism about the speed
                            if(contentSize < 400_000) return@withContext 0.0
                            val secondsTaken = (responseTime.timestamp - requestTime.timestamp) / 1_000.0

                            withContext(Dispatchers.Default) {
                                if (contentSize > 0 && secondsTaken > 0) {
                                    val speedBps = contentSize / secondsTaken // bps
                                    speedBps / 1_000_000.0 // Mbps
                                } else 0.0
                            }
                        }
                    }
                    
                    ResponseObserver { response -> 
                         val speedMbps = response.speedInMbps().roundToInt()
                         
                         networkSpeed  {
                            when {
                                    speedMbps <= 1.0 -> NetworkSpeed.VerySlow
                                    speedMbps <= 2.0 -> NetworkSpeed.Slow
                                    speedMbps <= 5.0 -> NetworkSpeed.Moderate
                                    speedMbps <= 10.0 -> NetworkSpeed.Good
                                    else -> NetworkSpeed.Fast
                                }.takeIf { speedMbps != 0 }
                            } else null,
                        }
                    """.trimIndent()
            )

            SpanText(
                text = "BaseURL Platform Specific",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/by-tezov/tuucho
            KotlinCode(
                code = $$"""
                    //commonMain
                    expect fun NetworkRepositoryModule.serverUrlEndpoint(): String 
                    
                    //iosMain
                    import io.ktor.client.engine.HttpClientEngineFactory
                    import io.ktor.client.engine.darwin.Darwin
                    import org.koin.dsl.module

                    actual fun NetworkRepositoryModule.serverUrlEndpoint() = "http://127.0.0.1:3000"
                    
                    object NetworkRepositoryModuleIos {
                        internal operator fun invoke() = module {
                            factory<HttpClientEngineFactory<*>> {
                                Darwin
                            }
                        }
                    }
                    
                    //androidMain
                    import io.ktor.client.engine.HttpClientEngineFactory
                    import io.ktor.client.engine.okhttp.OkHttp
                    import org.koin.dsl.module

                    actual fun NetworkRepositoryModule.serverUrlEndpoint() = "http://10.0.2.2:3000"
                    
                    object NetworkRepositoryModuleAndroid {
                        internal operator fun invoke() = module {
                            factory <HttpClientEngineFactory<*>> {
                                OkHttp
                            }
                        }
                    }
                    
                    //commonMain
                    expect fun SystemCoreDataModules.platformInvoke(): List<Module>
                    
                    object SystemCoreDataModules {
                        operator fun invoke():List<Module> = listOf(
                            NetworkRepositoryModule(),
                        ) + platformInvoke()
                    }
                    
                    //iosMain
                    actual fun SystemCoreDataModules.platformInvoke() = listOf()
                    
                    //androidMain
                    actual fun SystemCoreDataModules.platformInvoke() = listOf()

                    
                    import io.ktor.client.HttpClient
                    import io.ktor.client.engine.HttpClientEngineFactory
                    import io.ktor.client.plugins.HttpResponseValidator
                    import io.ktor.client.plugins.HttpTimeout
                    import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
                    import io.ktor.serialization.kotlinx.json.json
                    import kotlinx.serialization.json.Json
                    import org.koin.dsl.module

                    expect fun NetworkRepositoryModule.serverUrlEndpoint(): String //TODO external config file (android, ios, common)
                    private const val serverConnectTimeoutMillis = 5000L
                    private const val serverSocketTimeoutMillis = 5000L

                    object NetworkRepositoryModule {

                        internal operator fun invoke() = module {
                            factory<HttpClient> {
                                HttpClient(get<HttpClientEngineFactory<*>>()) {
                                    install(ContentNegotiation) {
                                        json(get<Json>())
                                    }
                                    install(HttpTimeout) {
                                        connectTimeoutMillis = serverConnectTimeoutMillis
                                        socketTimeoutMillis = serverSocketTimeoutMillis
                                    }
                                    HttpResponseValidator {
                                        validateResponse { response ->
                                            val statusCode = response.status.value
                                            if (statusCode !in 200..299) {
                                                throw DataException.Default("Bad response received: $response")
                                            }
                                        }
                                        handleResponseExceptionWithRequest { cause, _ -> throw cause }
                                    }
                                }
                            }

                            factory<NetworkHttpRequest> {
                                NetworkHttpRequest(
                                    httpClient = get(),
                                    baseUrl = serverUrlEndpoint()
                                )
                            }

                            single<MaterialNetworkSource> {
                                MaterialNetworkSource(
                                    networkHttpRequest = get(),
                                    jsonConverter = get()
                                )
                            }
                        }
                    }
                    
                    sealed class DataException(throwable: Throwable): Exception(throwable) {
                        constructor(message: String) : this(Exception(message))
                        constructor(message: String, throwable: Throwable) : this(Exception(message, throwable))

                        class Default(throwable: Throwable): DataException(throwable) {
                            constructor(message: String) : this(Exception(message))
                            constructor(message: String, throwable: Throwable) : this(Exception(message, throwable))
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Default Request Configuration",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "defaultRequest { ... } sets default settings that will apply to every HTTP request made by this client unless overridden.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "url { ... } configures the base URL for requests.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "protocol = URLProtocol.HTTP specifies that the client should use the HTTP protocol.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "host = multiplatformdeveloper.com sets the default host to multiplatformdeveloper.com",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            KotlinCode(
                code = """
                    defaultRequest {
                        contentType(ContentType.Application.Json)
                        accept(ContentType.Application.Json)
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "HttpResponsePipeline.Transform",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "HttpClient Pipeline used for executing HttpResponse. HttpResponsePipeline is broken into several phases, and Transform is one of the last phases. It comes after the raw response has been received and parsed, and it's where deserialization or any custom data conversion happens.", modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                KotlinCode(
                    code = """
                        HttpResponsePipeline = [Receive, Parse, Transform, After]
                        """.trimIndent()
                )

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Receive: Gets the raw response stream.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Parse: Parses it into an intermediate format (like ByteReadChannel, String, etc.).",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Transform: Converts that parsed data into the expected type (T) — e.g., JSON → Kotlin object.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "After: Final cleanup or logging.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Deserialize response data",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Convert response content formats (e.g., ByteReadChannel → String → Data class)",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Customize how the response is interpreted",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "info contains metadata like the expected response type.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "content is the parsed data (from the previous phase).",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "proceedWith(HttpResponseContainer(...)) sends the transformed result to the next phase or the client.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Close Connection",
                modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/JetBrains/kotlinconf-app
            //https://github.com/xephosbot/AnilibriaRefresh
            KotlinCode(
                code = $$"""
                    class APIClient(
                        private val apiUrl: String,
                        private val appLogger: Logger,
                    ) : Closeable {

                        companion object {
                            private const val LOG_TAG = "APIClient"
                        }

                        var userId: String? = null

                        private val client = HttpClient {
                            install(ContentNegotiation) {
                                json()
                            }

                            install(Logging) {
                                level = LogLevel.HEADERS
                                logger = object : KtorLogger {
                                    override fun log(message: String) {
                                        appLogger.log(LOG_TAG) { message }
                                    }
                                }
                            }

                            expectSuccess = true
                            install(HttpTimeout) {
                                requestTimeoutMillis = 5000
                            }

                            install(HttpRequestRetry) {
                                retryOnServerErrors(maxRetries = 3)
                                exponentialDelay()
                            }
                            
                            /*
                            install(HttpRequestRetry) {
                                maxRetries = 2
                                retryIf { _, response ->
                                    response.status.value == 525 ||
                                        response.status.value == HttpStatusCode.BadGateway.value
                                }
                                modifyRequest { request ->
                                    if (request.url.host == "anilibria.top") {
                                        request.url.host = "anilibria.wtf"
                                    }
                                }
                            }*/

                            install(DefaultRequest) {
                                url.takeFrom(apiUrl)
                            }
                        }

                        /**
                         * @return status of request.
                         */
                        suspend fun sign(userId :String): Boolean {
                            return safeApiCall {
                                client.post {
                                    apiUrl("sign")
                                    setBody(userId)
                                }.status.isSuccess()
                            } ?: false
                        }

                        /**
                         * Get [ConferenceData] info
                         */
                        suspend fun downloadConferenceData(): Conference? {
                            return safeApiCall {
                                client.get("conference").body()
                            }
                        }

                        /**
                         * Vote for session.
                         */
                        suspend fun vote(sessionId: SessionId, score: Score?): Boolean {
                            if (userId == null) return false

                            return safeApiCall {
                                client.post {
                                    apiUrl("vote")
                                    json()
                                    setBody(VoteInfo(sessionId, score))
                                }.status.isSuccess()
                            } ?: false
                        }

                        /**
                         * Send feedback
                         */
                        suspend fun sendFeedback(sessionId: SessionId, feedback: String): Boolean {
                            if (userId == null) return false

                            return safeApiCall {
                                client.post {
                                    apiUrl("feedback")
                                    json()
                                    setBody(FeedbackInfo(sessionId, feedback))
                                }.status.isSuccess()
                            } ?: false
                        }

                        /**
                         * List my votes.
                         */
                        suspend fun myVotes(): List<VoteInfo> {
                            if (userId == null) return emptyList()

                            return safeApiCall {
                                client.get { apiUrl("vote") }.body<Votes>().votes
                            } ?: emptyList()
                        }

                        suspend fun getServerTime(): Instant? {
                            return safeApiCall {
                                client.get { apiUrl("time") }.bodyAsText()
                                    .let { response -> Instant.fromEpochMilliseconds(response.toLong()) }
                            }
                        }

                        suspend fun getNews(): List<NewsItem>? {
                            return safeApiCall { client.get("news").body<NewsListResponse>().items }
                        }

                        /**
                         * Runs the [call], returning its result or `null` if exceptions occurred.
                         */
                        private suspend fun <T> safeApiCall(
                            call: suspend () -> T,
                        ): T? {
                            return try {
                                call()
                            } catch (e: CancellationException) {
                                throw e
                            } catch (e: Exception) {
                                appLogger.log(LOG_TAG) { "API call failed: ${e.message}" }
                                null
                            }
                        }

                        private fun HttpRequestBuilder.json() {
                            contentType(ContentType.Application.Json)
                        }

                        private fun HttpRequestBuilder.apiUrl(path: String) {
                            if (userId != null) {
                                header(HttpHeaders.Authorization, "Bearer $userId")
                            }

                            header(HttpHeaders.CacheControl, "no-cache")

                            url {
                                encodedPath = path
                            }
                        }

                        override fun close() {
                            client.close()
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "HttpRequestRetry",
                modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/dontknow492/Zeku.git
            KotlinCode(
                code = """
                    expect fun provideHttpClientEngine(): HttpClientEngine
                    
                    //androidMain
                    actual fun provideHttpClientEngine(): HttpClientEngine {
                        return OkHttp.create {
                            config {
                                // Crucial for mobile devices switching between WiFi and Cellular
                                retryOnConnectionFailure(true)
                            }
                        }
                    }
                    
                    //jvmMain
                    actual fun provideHttpClientEngine(): HttpClientEngine {
                        return CIO.create {
                            // Useful later if you implement batch downloading (e.g., 20 manga pages at once)
                            maxConnectionsCount = 1000
                            endpoint {
                                maxConnectionsPerRoute = 100
                            }
                        }
                    }
                    
                    // 3. RETRIES (Crucial for mobile networks)
                    install(HttpRequestRetry) {
                        retryOnServerErrors(maxRetries = 3) // Retries on 500, 502, 503, 504
                        retryOnExceptionIf { request, cause ->
                        // Retry if the network drops temporarily
                        cause is SocketTimeoutException ||
                            cause is UnknownHostException
                        }   
                        exponentialDelay() // Waits 1s, then 2s, then 4s between retries
                    }
                    
                    // 4. Retry 500...599
                    install(HttpRequestRetry) {
                        maxRetries = 3
                        retryIf { _, response ->
                            response.status.value in 500..599
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "DebugAntilog filter",
                modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    /*
                    val ResourceModule = SerializersModule {
                        polymorphic(Resource::class) {
                            subclass(Source::class, Source.serializer())
                            subclass(Payment::class, Payment.serializer())
                            subclass(PaymentIntent::class, PaymentIntent.serializer())
                            subclass(Webhook::class, Webhook.serializer())
                        }
                    }*/

                    @OptIn(ExperimentalSerializationApi::class)
                    fun networkModule() = module {
                        single {
                            HttpClient {
                                defaultRequest {
                                    url(Constant.BASE_URL)
                                }
                                expectSuccess = true

                                install(HttpCache)

                                install(HttpTimeout) {
                                    connectTimeoutMillis = 30.seconds.inWholeMilliseconds
                                    requestTimeoutMillis = 30.seconds.inWholeMilliseconds
                                    socketTimeoutMillis = 2.minutes.inWholeMilliseconds
                                }

                                install(ContentNegotiation) {
                                    json(Json {
                                        //declare Kotlinx.json JSON serializer
                                        explicitNulls = false
                                        prettyPrint = true
                                        isLenient = true
                                        //Specifies whether encounters of unknown properties in the input JSON should be ignored instead of throwing SerializationException
                                        ignoreUnknownKeys = true

                                        encodeDefaults = true
                                        useAlternativeNames = true

                                        classDiscriminator = "type"

                                        /** JSON value is null but the property type is non-nullable.
                                        Property type is an enum type, but JSON value contains an unknown enum member. 
                                        When the API returns null for a field your DTO defaults tofalse, it falls back to the default instead of throwing.
                                        */
                                        coerceInputValues = true

                                        allowStructuredMapKeys = true

                                        //serializersModule = ResourceModule
                                        serializersModule = ApiSection.serializers + ApiSectionHeader.serializers + ApiCarouselItem.serializers + ApiListItem.serializers + ApiAction.serializers
                                    })
                                }

                                //CacheStorage
                                install(HttpCache) {
                                    publicStorage(CacheStorage.Disabled)
                                }

                                install(Logging) {
                                    logger = object : Logger {
                                        override fun log(message: String) {

                                        }
                                    }
                                    level = LogLevel.ALL
                                }.also { Napier.base(DebugAntilog()) }

                                /* 
                                install(Logging) {
                                    logger = Logger. SIMPLE
                                    level = LogLevel. ALL
                                    filter { request ->
                                        request.url.host.contains("BASE URL")
                                    }
                                } */

                                /*
                                install(Logging) {
                                    logger = Logger.DEFAULT
                                    level = LogLevel.ALL
                                    logger = object : Logger {
                                        override fun log(message: String) {
                                                co.touchlab.kermit.Logger.d(tag = "KtorClient", null) {
                                                message
                                            }
                                        }
                                    }
                                }

                                install(ResponseObserver) {
                                    onResponse { response ->
                                        co.touchlab.kermit.Logger.d(tag = "HTTP status:", null) {
                                            response.status.value.toString()
                                        }
                                    }
                                } */

                                install(HttpTimeout) {
                                    connectTimeoutMillis  = 15.seconds.inWholeMilliseconds // connectTimeout
                                    socketTimeoutMillis   = 60.seconds.inWholeMilliseconds // readTimeout
                                    requestTimeoutMillis  = 60.seconds.inWholeMilliseconds // callTimeout
                                }

                                install(Auth) {
                                    basic {
                                        sendWithoutRequest { true }
                                        credentials {
                                            BasicAuthCredentials(username = config.secretKey, password = "")
                                        }
                                    }
                                }
                            }
                        }
                    }
                    """.trimIndent()
            )

            //https://github.com/maeceloacm1998/Comu-Carona-APP-KMP
            KotlinCode(
                code = $$"""
            suspend inline fun <reified T> HttpResponse.handleResultResponse(): Result<T> {
                return if (status == HttpStatusCode.OK) {
                    val checkCodeResponse = this.body<T>()
                    Result.success(checkCodeResponse)
                } else {
                    Result.failure(Throwable("Error: ${status.value}"))
                }
            }""".trimIndent())

            //https://github.com/beHqo/MockStore
            KotlinCode(
                code = $$"""
                    //1. Handle Error
                    HttpResponseValidator {
                        handleResponseExceptionWithRequest { exception, request ->
                            val responseException =
                                exception as? ResponseException ?: return@handleResponseExceptionWithRequest
                            val exceptionResponse = responseException.response
                            val exceptionResponseStatus = exceptionResponse.status

                            throw ResponseException(
                                response = exceptionResponse,
                                cachedResponseText = "#${exceptionResponseStatus.value}: ${exceptionResponseStatus.description}"
                            )
                        }
                    }
                    
                    //2. Handle Error
                     HttpResponseValidator {
                        validateResponse { response: HttpResponse ->
                            val statusCode = response.status.value
                            when (statusCode) {
                                in 300..399 -> throw RedirectResponseException(response, "")
                                in 400..499 -> throw ClientRequestException(response, "")
                                in 500..599 -> throw ServerResponseException(response, "")
                            }

                            if (statusCode >= 600) {
                                throw ResponseException(response, "")
                            }
                        }

                        handleResponseExceptionWithRequest { cause: Throwable, request: HttpRequest ->
                            val error = when (cause) {
                                is ClientRequestException -> getError(cause.response.content)
                                else -> throw cause
                            }
                            throw PayMongoException(error.errors)
                        }
                    }

                    private suspend fun getError(responseContent: ByteReadChannel): PayMongoErrorResponse {
                        responseContent.readUTF8Line()?.let {
                            return PaymongoJson.decodeFromString(it)
                        }
                        throw IllegalArgumentException("not a parsable error")
                    }
                    
                    """.trimIndent()
            )

            //https://github.com/EEseka/ShelfLife (safeFirebaseAuthCall, platformSafeCall KTOR, Notification, PickedImage)
            KotlinCode(
                code = """
                    interface Error
                    
                    sealed interface DataError : Error {
                        enum class Auth : DataError {
                            UNAUTHORIZED,       // 401: Invalid email or password
                            FORBIDDEN,          // 403: Sensitive operation requires recent login
                            CONFLICT,           // 409: Account with this email already exists
                            NO_INTERNET,        //
                            UNKNOWN             // Catch-all auth error
                        }

                        enum class RemoteStorage : DataError {
                            BAD_REQUEST,        // 400: Invalid Firestore/Storage request
                            NOT_FOUND,          // 404: Document/file not found
                            REQUEST_TIMEOUT,    // 408: Request took too long
                            CONFLICT,           // 409: Document already exists
                            NO_INTERNET,        // Offline
                            SERVER_ERROR,       // 500: Firebase server error
                            SERIALIZATION,      // JSON parsing failed (Firestore)
                            PERMISSION_DENIED,  // Firestore security rules denied access
                            QUOTA_EXCEEDED,     // Storage quota exceeded
                            TOO_MANY_REQUESTS,  // 429: Rate limit exceeded
                            UNKNOWN             // Catch-all storage error
                        }

                        enum class Remote : DataError {
                            BAD_REQUEST,        // 400: Invalid API request
                            UNAUTHORIZED,        // 401: User is not authenticated
                            FORBIDDEN,           // 403: User is authenticated but doesn't have permission
                            NOT_FOUND,          // 404: Resource not found (e.g., barcode in OpenFoodFacts)
                            REQUEST_TIMEOUT,    // 408: Request took too long
                            CONFLICT,            // 409: Resource already exists or conflict in state
                            PAYLOAD_TOO_LARGE,   // 413: Upload size is too big
                            TOO_MANY_REQUESTS,  // 429: API rate limit exceeded
                            NO_INTERNET,        // Offline
                            SERVER_ERROR,       // 500: API server error
                            SERVICE_UNAVAILABLE, // 503: Server is down or maintenance
                            SERIALIZATION,      // JSON parsing failed
                            UNKNOWN             // Catch-all API error
                        }

                        enum class LocalStorage : DataError {
                            DISK_FULL,          // Device out of space (Room/Storage)
                            NOT_FOUND,          // Item not found in local Room DB
                            UNKNOWN             // Local IO error
                        }
                    }
                    """.trimIndent()
            )

            //https://github.com/rubenquadros/TimeToWish-App (KTOR, Common UseCase)
            KotlinCode(
                code = """
                    //ApiManager.kt
                    import io.ktor.client.HttpClient
                    import io.ktor.client.plugins.*
                    import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
                    import io.ktor.client.plugins.logging.Logging
                    import io.ktor.client.plugins.logging.LogLevel
                    import io.ktor.client.request.*
                    import io.ktor.client.statement.HttpResponseContainer
                    import io.ktor.client.statement.HttpResponsePipeline
                    import io.ktor.http.*
                    import io.ktor.serialization.kotlinx.json.json
                    import io.ktor.util.*
                    import kotlinx.serialization.json.Json
                    import org.koin.core.annotation.Single

                    interface ApiManager {
                        val client: HttpClient
                    }

                    @Single
                    internal class ApiManagerImpl(private val userSession: UserSession) : ApiManager {
                        override val client: HttpClient by lazy { getHttpClient() }

                        private fun getHttpClient(): HttpClient {
                            return HttpClient(
                                engine = getHttpClientEngine()
                            ){
                                install(ContentNegotiation) {
                                    json(Json {
                                        isLenient = true
                                        ignoreUnknownKeys = true
                                        prettyPrint = true
                                        encodeDefaults = true
                                        explicitNulls = false
                                    })
                                }

                                install(Logging) {
                                    level = LogLevel.ALL
                                }

                                /*
                                install(Logging) {
                                    logger = Logger.DEFAULT
                                    level = LogLevel.BODY
                                    sanitizeHeader { header -> header == HttpHeaders.Authorization }
                                }
                                */

                                defaultRequest {
                                    url {
                                        host = "timetowish-server.onrender.com"
                                        protocol = URLProtocol.HTTPS
                                    }

                                    contentType(ContentType.Application.Json)
                                }
                            }.also { httpClient ->
                                httpClient.apply {
                                    addRequestInterceptor(userSession)
                                    addResponseInterceptor()
                                }
                            }
                        }

                        private fun HttpClient.addResponseInterceptor() {
                            responsePipeline.intercept(phase = HttpResponsePipeline.Transform) { (info, body) ->
                                if (context.response.status != HttpStatusCode.OK) {
                                    //parse error response and throw exception
                                    val response = body as ApiError
                                    throw ApiException(message = response.message)
                                }

                                proceedWith(HttpResponseContainer(info, body))
                            }
                        }

                        private fun HttpClient.addRequestInterceptor(userSession: UserSession) {
                            plugin(HttpSend).intercept { request ->
                                execute(request.addDefaultHeaders(userSession))
                            }
                        }

                        private suspend fun HttpRequestBuilder.addDefaultHeaders(userSession: UserSession): HttpRequestBuilder {
                            headers.appendAll(
                                StringValues.build {
                                    this["UserId"] = userSession.getUserId()
                                    this["Platform"] = getPlatform()
                                }
                            )

                            return this
                        }
                    }

                    //Error.kt
                    import kotlinx.serialization.Serializable

                    class ApiException(override val message: String): Exception(message)

                    @Serializable
                    data class ApiError(val message: String)

                    //HttpResponseBody.kt
                    import io.ktor.client.call.body
                    import io.ktor.client.statement.HttpResponse

                    suspend inline fun <reified T>HttpResponse.body(): T {
                        return this.body()
                    }

                    //HttpClientEngine.kt
                    import io.ktor.client.engine.HttpClientEngine
                    expect fun getHttpClientEngine(): HttpClientEngine

                    //iosMain
                    import io.ktor.client.engine.HttpClientEngine
                    import io.ktor.client.engine.darwin.Darwin

                    actual fun getHttpClientEngine(): HttpClientEngine = Darwin.create()

                    //androidMain
                    import io.ktor.client.engine.HttpClientEngine
                    import io.ktor.client.engine.okhttp.OkHttp

                    actual fun getHttpClientEngine(): HttpClientEngine = OkHttp.create()
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    // TODO: Remove this interceptor when the backend fixes the content type - Backend is just RAW text file in GitHub

                    @OptIn(InternalAPI::class)
                    private fun HttpClient.addGitHubRawTextContentTypeToJsonInterceptor(): HttpClient = apply {
                        receivePipeline.intercept(HttpReceivePipeline.Before) { response ->
                            this.proceedWith(object : HttpResponse() {
                                override val call: HttpClientCall = response.call
                                override val content: ByteReadChannel = response.content
                                override val coroutineContext: CoroutineContext = response.coroutineContext
                                override val headers: Headers = HeadersBuilder().apply {
                                    appendAll(response.headers)
                                    this.remove(HttpHeaders.ContentType)
                                    this.append(HttpHeaders.ContentType, "application/json")
                                }.build()
                                override val requestTime: GMTDate = response.requestTime
                                override val responseTime: GMTDate = response.responseTime
                                override val status: HttpStatusCode = response.status
                                override val version: HttpProtocolVersion = response.version
                            })
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    val client = HttpClient(Darwin) {
                        engine { // this: DarwinClientEngineConfig }
                    }

                    actual fun getClientEngine(): HttpClientEngine = Darwin.create()
                    """.trimIndent()
            )

            //https://github.com/maeceloacm1998/DevLanguages
            KotlinCode(
                code = """
                    //HttpClient close
                    
                    val networkModule = module {
                        // Ktor HttpClient
                        single<HttpClient> { HttpClientProvider.client }
                    }
                    
                    /**
                     * Ktor HTTP Client Configuration
                    */

                    fun createHttpClient(): HttpClient {
                        return HttpClient {
                            // Content Negotiation - JSON serialization/deserialization
                            install(ContentNegotiation) {
                                json(Json {
                                    prettyPrint = true
                                    isLenient = true
                                    ignoreUnknownKeys = true 
                                    encodeDefaults = true
                                    explicitNulls = false
                                })
                            }

                            // Logging 
                            install(Logging) {
                                logger = object : Logger {
                                    override fun log(message: String) {
                                        Napier.d(tag = "HTTP Client", message = message)
                                    }
                                }
                                level = LogLevel.HEADERS // ALL, HEADERS, BODY, INFO, NONE
                            }

                            // Default Request 
                            defaultRequest {
                                header(HttpHeaders.ContentType, ContentType.Application.Json)
                            }

                            // expectSuccess = true 
                        }
                    }
                    
                    object HttpClientProvider {
                        val client: HttpClient by lazy {
                            createHttpClient()
                        }

                        fun close() {
                            client.close()
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "ResponseObserver",
                modifier = Modifier.fontSize(FontSize.Large).padding(bottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                        install(ResponseObserver) {
                            onResponse { response ->
                                println(response.status.value)
                            }
                        }

                        //time difference
                        ResponseObserver {
                            val timeDifference = it.responseTime.timestamp - it.requestTime.timestamp
                            val protocolVersion = it.version
                        }

                        //HttpClient
                        val client = HttpClient()
                        ResponseObserver.install(ResponseObserver {
                            println("Bonjour!")
                        }, client)
                """.trimIndent()
            )

            SpanText(
                text = "AutoCloseable",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = $$"""
                    //https://github.com/kagg886/Pixko

                    suspend fun PixivAccount.searchUser(
                        keyword: String,
                        page: Int = 1,
                    ): List<User> {
                        return client.get("v1/search/user") {
                            parameter("word", keyword)
                            parameter("offset", (page - 1) * 30)
                        }.body<JsonElement>().jsonObject["user_previews"]!!.jsonArray.map {
                            json.decodeFromJsonElement<User>(it.jsonObject["user"]!!)
                        }
                    }

                    internal val json = Json {
                        ignoreUnknownKeys = true
                    }

                    data class PixivException(
                        val url: String,
                        val body: String,
                        override val cause: Throwable? = null
                    ) : Exception() {
                        val serverMessage by lazy {
                            kotlin.runCatching {
                                json.decodeFromString<JsonElement>(body)
                                    .jsonObject["error"]!!
                                    .jsonObject["user_message"]!!
                                    .jsonPrimitive
                                    .content
                            }.getOrNull()
                        }
                    }

                    class InvaidRefreshTokenException : Exception()

                    enum class TokenType {
                        ACCESS, REFRESH
                    }

                    /**
                     * # Token
                     * @see InMemoryTokenStorage
                     */
                    interface TokenStorage {
                        fun getToken(type: TokenType): String?
                        fun setToken(type: TokenType, token: String)
                    }

                    class InMemoryTokenStorage : TokenStorage {
                        private val map = mutableMapOf<TokenType, String>()
                        override fun getToken(type: TokenType): String? = map[type]

                        override fun setToken(type: TokenType, token: String) {
                            map[type] = token
                        }
                    }

                    class PixivAccountConfig<Engine : HttpClientEngineConfig>(val engine: HttpClientEngineFactory<Engine>) {
                        var config: HttpClientConfig<Engine>.() -> Unit = {}

                        var storage: TokenStorage = InMemoryTokenStorage()
                        var language: String? = ""
                    }


                    typealias PixivAccount = InternalPixivAccount<*>

                    class InternalPixivAccount<Engine : HttpClientEngineConfig> internal constructor(
                        private val config: PixivAccountConfig<Engine>
                    ) : AutoCloseable {

                        internal val client = HttpClient(config.engine) {
                            config.config(this)

                            install(ContentNegotiation) {
                                json(top.kagg886.pixko.internal.json)
                            }


                            install(TokenAutoRefreshPluginV2) {
                                storage = config.storage
                            }

                            install(HttpTimeout) {
                                requestTimeoutMillis = 30000
                                socketTimeoutMillis = 30000
                                connectTimeoutMillis = 30000
                            }

                            defaultRequest {
                                url("h")
                                header("Accept-Language", config.language)
                                header("Referer", "")
                            }
                        }

                        override fun close() {
                            client.close()
                        }
                    }

                    @KtorDsl
                    class TokenAutoRefreshPluginV2Config {
                        lateinit var storage: TokenStorage
                    }

                    @OptIn(InternalAPI::class)
                    val TokenAutoRefreshPluginV2 = createClientPlugin("TokenAutoRefreshPluginV2", ::TokenAutoRefreshPluginV2Config) {
                        val storage = pluginConfig.storage


                        onRequest { request, _ ->
                            request.headers["Authorization"] = "Bearer ${storage.getToken(TokenType.ACCESS)}"
                        }


                        on(Send) { originalRequest ->
                            val origin = proceed(originalRequest)
                            if (origin.response.status == HttpStatusCode.OK) return@on origin

                            val body = origin.response.bodyAsBytes()

                            with(body.decodeToString()) {
                                if (!(contains("Invalid access token") || contains("Error occurred at the OAuth process"))) {
                                    if (this.contains("Invalid refresh token")) {
                                        throw InvaidRefreshTokenException()
                                    }
                                    throw PixivException(origin.request.url.toString(), this)
                                }
                            }

                            val resp = client.post("https://oauth.secure.pixiv.net/auth/token") {
                                contentType(ContentType.Application.FormUrlEncoded)
                                setBody(
                                    FormDataContent(
                                        Parameters.build {
                                            append("client_id", "")
                                            append("client_secret", "")
                                            append("grant_type", "refresh_token")
                                            append("refresh_token", storage.getToken(TokenType.REFRESH)!!)
                                            append("include_policy", "true")
                                        }
                                    )
                                )
                            }

                            val json = resp.body<JsonElement>().jsonObject

                            val accessToken = json["access_token"]?.jsonPrimitive?.content
                                ?: throw InvaidRefreshTokenException()

                            storage.setToken(TokenType.ACCESS, accessToken)

                            val newRequest = HttpRequestBuilder().apply {
                                takeFromWithExecutionContext(originalRequest)
                                headers["Authorization"] = "Bearer $accessToken"
                            }
                            return@on proceed(newRequest)
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Dynamic Auth",
                modifier = Modifier.fontSize(FontSize.Large).padding(bottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    class Requests(private val settings: Settings) {
                        private fun <T : HttpClientEngineConfig> HttpClientConfig<T>.commonConfig() {
                            install(ContentNegotiation) {
                                json(
                                    Json {
                                        prettyPrint = true
                                        isLenient = true
                                        ignoreUnknownKeys = true
                                        encodeDefaults = true
                                    },
                                )
                            }
                            install(Logging) {
                                logger = DebugKtorLogger()
                                level = LogLevel.BODY
                            }
                        }

                        private val geminiClient = httpClient {
                            commonConfig()
                        }

                        private val groqClient = httpClient {
                            commonConfig()
                            install(Auth) {
                                bearer {
                                    sendWithoutRequest { request ->
                                        true
                                    }

                                    loadTokens {
                                        BearerTokens(
                                            settings.getString(Key.GROQ_API_KEY, Value.DEFAULT_GROQ_API_KEY),
                                            null
                                        )
                                    }
                                    refreshTokens {
                                        BearerTokens(
                                            settings.getString(Key.GROQ_API_KEY, Value.DEFAULT_GROQ_API_KEY),
                                            null
                                        )
                                    }
                                }
                            }
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Path url
                    private const val BASE_URL = "https://pixabay.com/"
                    private const val API_KEY = "47484736-416e0b62cb618ec6f78314d6f"

                    abstract class KtorApi {
                        val client = HttpClient {
                            install(ContentNegotiation) {
                                json(Json{
                                    ignoreUnknownKeys = true
                                    useAlternativeNames = false
                                })
                            }
                        }

                        fun HttpRequestBuilder.pathUrl(path: String) {
                            url {
                                takeFrom(BASE_URL)
                                path(path)
                                parameter("key", API_KEY)
                            }
                        }
                    }

                    class WallpaperService : KtorApi() {
                        suspend fun getWallpapers(perPage: Int = 10): WallpapersResponse = client.get {
                            pathUrl("api/")
                            parameter("order", "latest")
                            parameter("per_page", perPage)
                        }.body()
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "HttpResponseValidator, Refresh Token",
                modifier = Modifier.fontSize(FontSize.Large).padding(bottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/jonathanwdev/petappKMP
            //const val API_KEY = "R3ZxUpkQiC3l823bxxA4l08TsB40O81XkHrB2O2Lf5mOh4a4BE"
            //const val API_SECRET = "4eNWrJR1vTzzgRdybjzNfYAo3UXDmeY5lwDQ7WrP"
            KotlinCode(
                code = $$"""
                    class InitializeKtor {
                        lateinit var client: HttpClient
                        private var accessToken: String = ""

                        init {
                            startKtor()
                        }

                        companion object {
                            const val BASE_URL = "https://api.petfinder.com/v2/"
                            const val API_KEY = ""
                            const val API_SECRET = ""
                        }

                        private suspend fun refreshAccessToken(): TokenResponse {
                            val response = client.post("oauth2/token") {
                                contentType(ContentType.Application.FormUrlEncoded)
                                setBody(
                                    "grant_type=client_credentials&" +
                                            "client_id=${API_KEY&" +
                                            "client_secret=${API_SECRET"
                                )
                            }
                            return response.body<TokenResponse>()
                        }

                        private fun startKtor(): HttpClient {
                            client = HttpClient(CIO) {
                                expectSuccess = true
                                install(Logging) {
                                    logger = Logger.SIMPLE
                                    level = LogLevel.ALL
                                }
                                install(ContentNegotiation) {
                                    json(
                                        Json {
                                            prettyPrint = true
                                            isLenient = true
                                            ignoreUnknownKeys = true
                                        }
                                    )
                                }
                                install(Auth) {
                                    bearer {
                                        loadTokens {
                                            BearerTokens(
                                                accessToken,
                                                ""
                                            )
                                        }
                                        refreshTokens {
                                            val newTokens = refreshAccessToken()
                                            accessToken = newTokens.accessToken
                                            BearerTokens(newTokens.accessToken, "")
                                        }

                                    }
                                }

                                defaultRequest {
                                    url(BASE_URL)
                                    contentType(ContentType.Application.Json)
                                }

                                HttpResponseValidator {
                                    handleResponseExceptionWithRequest { cause, request ->
                                        throw if (cause is ClientRequestException) {
                                            val errorMessage = cause.response.bodyAsText()
                                            NetworkException.ApiException(errorMessage, cause.response.status.value)
                                        } else {
                                            NetworkException.UnknownNetworkException(cause)
                                        }
                                    }
                                }
                            }
                            return client
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Base URL",
                modifier = Modifier.fontSize(FontSize.Large).padding(bottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                        fun String.toKtor() = "BASE URL"$this"
                    """.trimIndent()
            )

            SpanText(
                text = "Static pass data",
                modifier = Modifier.fontSize(FontSize.Large).padding(bottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    import kotlinx.serialization.Serializable

                    @Serializable
                    data class Workout(
                        val _id: String,
                        val title: String,
                        val date: String,
                        val duration: String,
                        val latitude: Double,
                        val longitude: Double
                    )

                    suspend fun setWorkout(workout: Workout) {
                        val workoutJson = json.encodeToString(Workout.serializer(), workout)
                        val response: HttpResponse = client.post("baseurl") {
                            header("Content-Type", "application/json")
                            header("Access-Control-Request-Headers", "*")
                            header("api-key", apiKey)
                            header("Accept", "application/json")
                            setBody( ""${'"'}
                                    {
                                        "dataSource": "Cluster0",
                                        "database": "Thesis",
                                        "collection": "post_workouts",
                                        "document": workoutJson
                                    }
                                ""${'"'}.trimIndent())
                        }
                        // Check the response status or handle it as needed
                        if (response.status != HttpStatusCode.OK) {
                            throw Exception(response.status)
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Status code handle",
                modifier = Modifier.fontSize(FontSize.Large).padding(bottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    suspend fun register(value: RegisterData): ApiResult<CreatedUser> {
                        return try {
                            val result = client.post("/user/register") { setBody(value) }
                            return if (result.status.value in 200..299) {
                                ApiResult.Success(result.body())
                            } else {
                                ApiResult.ServerError(status = result.status, message = result.body())
                            }
                        } catch (e: Exception) {
                            ApiResult.Failure(e.message)
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    private const val TIMEOUT_SECONDS = 5000L
                    private const val MAX_RETRIES = 5

                    val httpClient = HttpClient {
                        expectSuccess = true
                        loggerConfig()
                        engineConfig()
                        jsonConfig()
                        errorHandlerConfig()
                        defaultRequestConfig()
                    }.also { initNapier() }

                    fun HttpClientConfig<*>.engineConfig() {
                        engine {
                            request {
                                timeout {
                                    requestTimeoutMillis = TIMEOUT_SECONDS
                                }
                                retry {
                                    retryOnExceptionOrServerErrors(maxRetries = MAX_RETRIES)
                                }
                            }
                        }
                    }

                    fun HttpClientConfig<*>.loggerConfig() {
                        install(Logging) {
                            level = LogLevel.ALL
                            logger = object : Logger {
                                override fun log(message: String) {
                                    Napier.d(tag = "HTTP Client", message = message)
                                }
                            }
                        }
                    }

                    @OptIn(ExperimentalSerializationApi::class)
                    fun HttpClientConfig<*>.jsonConfig() {
                        install(ContentNegotiation) {
                            json(
                                json = Json {
                                    ignoreUnknownKeys = true
                                    prettyPrint = true
                                    explicitNulls = false
                                    // Set default value to expected values
                                    isLenient = true
                                }
                            )
                        }
                    }

                    fun HttpClientConfig<*>.errorHandlerConfig() {
                        HttpResponseValidator {
                            handleResponseExceptionWithRequest { cause, _ ->
                                Napier.e(cause.message.toString(), cause)
                                throw cause
                            }
                        }
                    }

                    fun HttpClientConfig<*>.defaultRequestConfig() {
                        defaultRequest {
                            url("https://jsonplaceholder.typicode.com")
                        }
                    }

                    fun initNapier() {
                        Napier.base(DebugAntilog())
                    }

                    //CoroutineExceptionHandler
                    data class HomeState(
                        val isLoading: Boolean,
                        val posts: List<PostResponse> = emptyList(),
                        val error: String? = null,
                    )

                    class HomeViewModel {
                        private val viewModelScope = CoroutineScope(Dispatchers.IO)

                        private val exceptionHandler = CoroutineExceptionHandler { _, throwable ->
                            runBlocking {
                                _stateFlow.emit(
                                    HomeState(
                                        isLoading = false,
                                        error = throwable.message.orEmpty()
                                    )
                                )
                            }
                        }

                        private val _stateFlow = MutableStateFlow(HomeState(isLoading = true))
                        val stateFlow: StateFlow<HomeState> = _stateFlow.asStateFlow()

                        fun loadPosts() = viewModelScope.launch(exceptionHandler) {
                            val response = getPosts()
                            _stateFlow.emit(
                                HomeState(
                                    isLoading = false,
                                    posts = response
                                )
                            )
                        }
                    }

                    data class HomeState(
                        val isLoading: Boolean,
                        val posts: List<PostResponse> = emptyList(),
                        val error: String? = null,
                    )

                    class HomeViewModel {

                        private val viewModelScope = CoroutineScope(Dispatchers.IO)

                        private val exceptionHandler = CoroutineExceptionHandler { _, throwable ->
                            runBlocking {
                                _stateFlow.emit(
                                    HomeState(
                                        isLoading = false,
                                        error = throwable.message.orEmpty()
                                    )
                                )
                            }
                        }

                        private val _stateFlow = MutableStateFlow(HomeState(isLoading = true))
                        val stateFlow: StateFlow<HomeState> = _stateFlow.asStateFlow()

                        fun loadPosts() = viewModelScope.launch(exceptionHandler) {
                            val response = getPosts()
                            _stateFlow.emit(
                                HomeState(
                                    isLoading = false,
                                    posts = response
                                )
                            )
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "interceptors",
                modifier = Modifier.fontSize(FontSize.Large).padding(bottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/vladislav-chetrari/Waifu-KMP
            KotlinCode(
                code = """
                    val networkModule by DI.Module {
                        bindSingleton<HttpClient> {
                            //apply multi-binding if needed, for now only internal interceptors are used
                            val interceptors = setOf<RestRequestInterceptor>(
                                AuthRequestInterceptor
                            )
                            val client = HttpClient(CIO) {
                                defaultRequest {
                                    url("")
                                }
                                
                                install(DefaultRequest) { 
                                    headers {
                                        appendIfNameAbsent(
                                            HttpHeaders.ContentType,
                                            ContentType.Application.Json.toString()
                                        )
                                    }
                                }
                                
                                install(ContentNegotiation) {
                                    json(Json {
                                        prettyPrint = true
                                        ignoreUnknownKeys = true
                                        isLenient = true
                                    })
                                }
                                install(Logging) {
                                    logger = NetworkLogger
                                    level = LogLevel.ALL
                                }
                            }
                            client.plugin(HttpSend).intercept { requestBuilder ->
                                val newRequestBuilder = interceptors
                                    .fold(requestBuilder) { request, interceptor -> interceptor.intercept(request) }
                                execute(newRequestBuilder)
                            }
                            client
                        }
                    }

                    internal object NetworkLogger : Logger {
                        override fun log(message: String) = Kermit.d { message }
                    }

                    internal interface RestRequestInterceptor {
                        suspend fun intercept(httpRequestBuilder: HttpRequestBuilder): HttpRequestBuilder
                    }

                    internal object AuthRequestInterceptor : RestRequestInterceptor {
                        override suspend fun intercept(httpRequestBuilder: HttpRequestBuilder): HttpRequestBuilder {
                            httpRequestBuilder.header("Authorization", "")
                            return httpRequestBuilder
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Custom Header using createClientPlugin",
                modifier = Modifier.fontSize(FontSize.Large).padding(bottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/vincenzosarnataro/UsersKMP.git
            KotlinCode(
                code = """
                    @Module
                    class NetworkModule {
                        object Constants {
                            const val BASE_URL = "https://reqres.in/api/"
                        }

                        @Single
                        fun provideHttpClient(): HttpClient = HttpClient {
                            install(ContentNegotiation) {
                                json(Json {
                                    ignoreUnknownKeys = true
                                    prettyPrint = true
                                    isLenient = true
                                })
                            }
                            install(Logging) {
                                logger = object : Logger {
                                    override fun log(message: String) {
                                        Napier.v(message)
                                    }
                                }
                                level = LogLevel.ALL
                            }
                            install(userAuthPlugin)
                        }.also { Napier.base(DebugAntilog()) }

                        @Single
                        fun provideKtorfit(client: HttpClient): Ktorfit =
                            Ktorfit.Builder()
                                .baseUrl(Constants.BASE_URL)
                                .httpClient(client)
                                .build()

                        @Single
                        fun provideUserApiService(ktorfit: Ktorfit): UserApiService =
                            ktorfit.createUserApiService()
                    }
                    
                    //UserAuthPlugin.kt
                    val userAuthPlugin = createClientPlugin("UserAuthPlugin", ::UserAuthPluginConfig) {
                        onRequest { request, _ ->
                            val apiKey = this@createClientPlugin.pluginConfig.apiKey
                            request.headers.append("x-api-key", apiKey)
                        }
                    }

                    class UserAuthPluginConfig {
                        var apiKey: String = "reqres-free-v1"
                    }
                    
                    fun initApplication(appDeclaration: KoinAppDeclaration = {}): KoinApplication {
                        return startKoin {
                            appDeclaration()
                            modules(
                                AppModule().module,
                            )
                        }
                    }

                    @Module(
                        includes = [
                            NetworkModule::class,
                            RepositoryModule::class,
                            UseCaseModule::class,
                            ViewModelModule::class
                        ]
                    )
                    class AppModule

                    @Suppress("unused") //using in iOS
                    fun initKoin() = initApplication {}
                    
                    @Module
                    @ComponentScan("com.example.usersapp.domain.usecase")
                    class UseCaseModule
                    
                    @Module
                    @ComponentScan("com.example.usersapp.presentation")
                    class ViewModelModule
                    
                    @Module
                    @ComponentScan("com.example.usersapp.data.repository")
                    class RepositoryModule
                    
                    //UserRepository.kt
                    interface UserRepository {
                        fun getUsers(page: Int): Flow<List<User>>
                        fun getUserDetails(id: Int): Flow<User>
                    }
                    
                    //UserRepositoryImpl.kt
                    @Single
                    class UserRepositoryImpl(private val userApi: UserApiService) : UserRepository {
                        override fun getUsers(page: Int): Flow<List<User>> = flow {
                            val user = userApi.getUsers(page).data.toModel()
                            emit(user)
                        }

                        override fun getUserDetails(id: Int): Flow<User> = flow {
                            val user = userApi.getDetails(id).data.toModel()
                            emit(user)
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Safe API Call",
                modifier = Modifier.fontSize(FontSize.Large).padding(bottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/pitampoudel/komposeauth.git
            KotlinCode(
                code = $$"""
                    //Response.kt
                    @Serializable
                    data class MessageResponse(
                        @SerialName("message")
                        val message: String
                    )

                    @Serializable
                    data class ErrorResponse(
                        @SerialName("error")
                        val error: String
                    )

                    @Serializable
                    data class DetailResponse(
                        @SerialName("detail")
                        val detail: String,
                        @SerialName("status_code")
                        val statusCode: Int? = null
                    )

                    @Serializable
                    data class GoogleErrorResponse(
                        @SerialName("error")
                        val error: Error
                    ) {
                        @Serializable
                        data class Error(
                            @SerialName("code")
                            val code: Int,
                            @SerialName("message")
                            val message: String,
                            @SerialName("status")
                            val status: String
                        )
                    }
                    
                    //Result.kt
                    import io.ktor.http.HttpStatusCode

                    sealed class Result<out T> {
                        data class Success<out T>(val data: T) : Result<T>()
                        open class Error(open val message: InfoMessage.Error) : Result<Nothing>() {
                            constructor(msg: String) : this(InfoMessage.Error(msg))

                            data class Http(
                                override val message: InfoMessage.Error,
                                val httpStatusCode: HttpStatusCode
                            ) : Error(message)
                        }
                    }
                    
                    //InfoMessage.kt
                    sealed interface InfoMessage {
                        val text: String

                        data class General(override val text: String) : InfoMessage
                        data class Success(override val text: String) : InfoMessage
                        data class Error(override val text: String) : InfoMessage
                    }

                    fun Throwable?.toInfoMessage(): InfoMessage {
                        return InfoMessage.Error(this?.message.orEmpty())
                    }
                    
                    //KtorClientUtils.kt
                    suspend fun downloadAll(
                        urls: List<String>
                    ): Result<List<KmpFile>> {
                        return safeApiCall {
                            val client = HttpClient()
                            var deferredList: List<Deferred<KmpFile>> = listOf()
                            coroutineScope {
                                deferredList = urls.map { imageUrl ->
                                    async {
                                        val response: HttpResponse = client.get(imageUrl)
                                        KmpFile(
                                            byteArray = response.readRawBytes(),
                                            mimeType = response.contentType()?.toString() ?: "application/octet-stream",
                                            name = imageUrl.substringAfterLast("/")
                                        )
                                    }
                                }
                            }
                            Result.Success(deferredList.awaitAll())
                        }
                    }

                    suspend fun download(
                        url: String
                    ): Result<KmpFile> {
                        val res = safeApiCall {
                            val client = HttpClient()
                            val response: HttpResponse = client.get(url)
                            Result.Success(
                                KmpFile(
                                    byteArray = response.readRawBytes(),
                                    mimeType = response.contentType()?.toString() ?: "application/octet-stream",
                                    name = url.substringAfterLast("/")
                                )
                            )
                        }
                        return res
                    }

                    suspend inline fun <reified T> HttpResponse.asResource(parse: HttpResponse.() -> T): Result<T> {
                        return try {
                            when (status.value) {
                                in 200..299 -> Result.Success(parse())
                                else -> {
                                    try {
                                        val message = body<MessageResponse>().message
                                        Result.Error.Http(InfoMessage.Error(message), this.status)
                                    } catch (e: JsonConvertException) {
                                        val message = body<ErrorResponse>().error
                                        Result.Error.Http(InfoMessage.Error(message), this.status)
                                    } catch (e: JsonConvertException) {
                                        val message = body<DetailResponse>().detail
                                        Result.Error.Http(InfoMessage.Error(message), this.status)
                                    } catch (e: JsonConvertException) {
                                        val message = body<GoogleErrorResponse>().error.message
                                        Result.Error.Http(InfoMessage.Error(message), this.status)
                                    } catch (e: JsonConvertException) {
                                        val message = bodyAsText()
                                        Result.Error.Http(InfoMessage.Error(message), this.status)
                                    }

                                }
                            }
                        } catch (ex: CancellationException) {
                            throw ex
                        } catch (e: JsonConvertException) {
                            e.printStackTrace()
                            // TODO don't show technical error message to user
                            Result.Error.Http(InfoMessage.Error(e.message.orEmpty()), this.status)
                        } catch (e: Exception) {
                            e.printStackTrace()
                            // TODO don't show technical error message to user
                            Result.Error.Http(InfoMessage.Error(e.message.orEmpty()), this.status)
                        }
                    }

                    suspend inline fun <reified T> safeApiCall(
                        crossinline apiCall: suspend () -> Result<T>
                    ): Result<T> {
                        return try {
                            apiCall.invoke()
                        } catch (ex: CancellationException) {
                            throw ex
                        } catch (ex: Exception) {
                            ex.printStackTrace()
                            // TODO don't show technical error message to user
                            Result.Error(InfoMessage.Error(ex.message.orEmpty()))
                        }
                    }
                    
                    internal class AuthClientImpl(val httpClient: HttpClient, val authUrl: String) : AuthClient {
                        override suspend fun fetchLoginConfig(platform: Platform): Result<LoginOptions> {
                            return safeApiCall {
                                httpClient.get("$authUrl/$LOGIN_OPTIONS") {
                                    parameter("platform", platform)
                                }.asResource { body<LoginOptions>() }
                            }
                        }
                    }
                    
                    internal interface AuthClient { 
                        suspend fun fetchLoginConfig(platform: Platform = Platform.WEB): Result<LoginOptions>
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "File Upload Progress",
                modifier = Modifier.fontSize(FontSize.Large).padding(bottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            /*
            expect class ImagePicker {
                suspend fun pickImage(): ImagePickerResult?
                suspend fun saveImageToGallery(imageData: ByteArray, fileName: String): Boolean
            }

            sealed class ImagePickerResult {
                data class Success(
                    val imageData: ByteArray,
                    val fileName: String,
                    val mimeType: String = "image/jpeg"
                ) : ImagePickerResult()

                data class Error(val message: String) : ImagePickerResult()
            }

            @Composable
            expect fun rememberImagePicker(): ImagePicker
            */

            KotlinCode(
                code = $$"""
                    //MultiPartFormDataContent

                    suspend fun uploadFileWithProgress(
                        fileByteArray: ByteArray,
                        fileName: String,
                        progressListener: (Long, Long) -> Unit
                    ): Result<UploadModel> = runCatching {
                        val basicInfo = BasicInfoReader.readConfigFile()

                        val response: HttpResponse =
                            httpClient.post("url") {
                                setBody(
                                    MultiPartFormDataContent(
                                        formData {
                                            append(key = "file", value = fileByteArray, headers = Headers.build {
                                                append(HttpHeaders.ContentType, "multipart")
                                                append(HttpHeaders.ContentDisposition, "filename=")
                                                
                                                 //append(HttpHeaders.ContentType, "image/jpeg")
                                                 //append(HttpHeaders.ContentDisposition, "filename=\"$fileName\"")
                                            })
                                        },
                                        boundary = "WebAppBoundary"
                                    )
                                )
                                onUpload { bytesSentTotal, contentLength ->
                                    progressListener(bytesSentTotal, contentLength)
                                }
                            }
                        response.body()
                    }

                    class ProfileRemoteViewModel : ViewModel() {
                        private val _uploadFileWithProgress = MutableStateFlow<Loadable<UploadModel>>(Loadable.NotLoading)
                        val uploadFileWithProgress = _uploadFileWithProgress.asStateFlow()

                        private val _uploadProgress = MutableStateFlow<Pair<Long, Long>>(0L to 0L)
                        val uploadProgress = _uploadProgress.asStateFlow()

                        private var uploadJob: Job? = null

                        fun uploadFileWithProgress(fileByteArray: ByteArray, fileName: String) {
                            uploadJob?.cancel() // Cancel any ongoing upload
                            uploadJob = viewModelScope.launch {
                                profileRepo.uploadFileWithProgress(fileByteArray, fileName) { bytesTransferred, totalBytes ->
                                    _uploadProgress.value = bytesTransferred to totalBytes
                                }.onSuccess {
                                    _uploadFileWithProgress.value = Loadable.Success(it)
                                }.onFailure {
                                    _uploadFileWithProgress.value = Loadable.Error(it)
                                }
                            }
                        }

                        fun cancelUpload() {
                            uploadJob?.cancel()
                        }

                        fun resetUpload() {
                            _uploadFileWithProgress.value = Loadable.NotLoading
                        }
                    }

                    @Composable
                    fun FileDetails(
                        profileRemoteViewModel: ProfileRemoteViewModel,
                        onFileUploaded: (String) -> Unit,
                        onLinkInserted: (String) -> Unit
                    ) {

                        val uploadProgress = profileRemoteViewModel.uploadProgress.collectAsState().value

                        LaunchedEffect(uploadProgress) {
                            val (bytesTransferred, totalBytes) = uploadProgress
                            if (totalBytes != 0L) {
                                uploadProgressPercentage = (bytesTransferred.toFloat() / totalBytes.toFloat()).coerceIn(0.0f, 1.0f)
                            }
                        }

                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    class PDFRepository(
                        private val client: HttpClient
                    ) {
                        suspend fun ocrPDFFile(file: ByteArray, languages: List<String>): ByteArray {
                            return client.post("") {
                                setBody(MultiPartFormDataContent(
                                    formData {
                                        languages.forEach {
                                            append("lang", it)
                                        }
                                        append("file", file, Headers.build {
                                            append(HttpHeaders.ContentType, "application/pdf")
                                            append(HttpHeaders.ContentDisposition, "filename=\"input.pdf\"")
                                        })
                                    }
                                ))
                            }.body<ByteArray>()
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //onUpload: (Float) -> Unit -> Function Argument Name

                    var currentProgress = 0f
                    var realProgress = 0f

                    onUpload { sendTotal: Long, contentLength: Long? ->
                        realProgress = sendTotal.toFloat() / (contentLength?.toFloat() ?: 1f)
                        if (sendTotal == contentLength || realProgress >= currentProgress + PROGRESS_STEP) {
                            currentProgress += PROGRESS_STEP
                            if (currentProgress > 1f) currentProgress = 1f
                                onUpload.invoke(currentProgress)
                        }
                    }

                    private companion object {
                        const val PROGRESS_STEP = 0.05f
                    }

                    //viewmodel    
                    private val uploadProgress: MutableStateFlow<UploadProgress> = MutableStateFlow(UploadProgress("", 0f))
                    fun observeUploadProgress(): Flow<UploadProgress> = uploadProgress

                    suspend fun upload(
                        attachment: AttachedFile,
                        onUpload: (Float) -> Unit = { updateProgress(attachment.id, it) },
                    ): Result<MediaAttachment> = runCatching {
                        val response: MediaAttachment = api.sendFile(
                            file = attachment.file,
                            onUpload = onUpload,
                            thumbnail = null,
                            description = null,
                            focus = null,
                        )

                        return@runCatching response
                    }

                    private fun updateProgress(id: String, progress: Float) {
                        uploadProgress.value = UploadProgress(id, progress)
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    suspend fun uploadFile(uploadUrl: String, file: File) {
                        val response: HttpResponse = client.submitFormWithBinaryData(
                            url = uploadUrl,
                            formData = formData {
                                append("description", "Test")
                                append("image", File("ktor_logo.png").readBytes(), Headers.build {
                                    append(HttpHeaders.ContentType, "image/png")
                                    append(HttpHeaders.ContentDisposition, "filename=\"ktor_logo.png\"")
                                })
                            }
                        )
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    interface KCWClient {
                        suspend fun uploadFile(path: String, byteArray: ByteArray, contentType: String, headers: Map<String, String> = emptyMap()): String

                        suspend fun getImage(blobUrl: String): ByteArray

                        companion object {
                            val client = defaultHttpClient

                            fun create(config: KCWConfig): KCWClient = KCWClientImpl(config)

                            suspend inline fun <reified T> get(url: String): T {
                                val response: HttpResponse = client.get(url)
                                return response.body()
                            }

                            suspend inline fun <reified T : Any, reified R> post(url: String, body: T): R {
                                val response: HttpResponse = client.post(url) {
                                    setBody(Json.encodeToString(body))
                                }
                                return response.body()
                            }

                            suspend inline fun <reified T, reified R> put(url: String, body: T): R {
                                val response: HttpResponse = client.put(url) {
                                    setBody(Json.encodeToString(body))
                                }
                                return response.body()
                            }

                            suspend inline fun <reified R> delete(url: String): R {
                                val response: HttpResponse = client.delete(url)
                                return response.body()
                            }

                            fun close() {
                                client.close()
                            }
                        }
                    }

                    class KCWClientImpl(private val config: KCWConfig) : KCWClient {
                        val client = defaultHttpClient
                        private val json = Json { ignoreUnknownKeys = true }

                        override suspend fun uploadFile(path: String, byteArray: ByteArray, contentType: String, headers: Map<String, String>): String {

                            val response: HttpResponse = client.put(UrlBuilder.buildUrl(config.baseUrl, path)) {
                                headers.forEach { (key, value) -> header(key, value) }

                                setBody(
                                    ByteArrayContent(
                                        bytes = byteArray,
                                        contentType = contentType.let { ContentType.parse(it) }
                                    )
                                )
                            }

                            if (response.status.isSuccess()) {
                                return response.bodyAsText()
                            } else {
                                throw KCWException(response.status)
                            }
                        }

                        override suspend fun getImage(blobUrl: String): ByteArray {
                            val response: HttpResponse = client.get(blobUrl) {
                                accept(ContentType.Image.Any)
                            }

                            if (response.status.isSuccess()) {
                                return response.bodyAsChannel().toByteArray()
                            } else {
                                throw KCWException(response.status)
                            }
                        }

                        suspend inline fun <reified T> get(url: String): T {
                            val response: HttpResponse = client.get(url)
                            return response.body()
                        }

                        suspend inline fun <reified T : Any, reified R> post(url: String, body: T): R {
                            val response: HttpResponse = client.post(url) {
                                setBody(Json.encodeToString(body))
                            }
                            return response.body()
                        }

                        suspend inline fun <reified T, reified R> put(url: String, body: T): R {
                            val response: HttpResponse = client.put(url) {
                                setBody(Json.encodeToString(body))
                            }
                            return response.body()
                        }

                        suspend inline fun <reified R> delete(url: String): R {
                            val response: HttpResponse = client.delete(url)
                            return response.body()
                        }

                        fun close() {
                            client.close()
                        }
                    }

                    class KCWException(message: String, cause: Throwable? = null) : Exception(message, cause)

                    object UrlBuilder {
                        fun buildUrl(baseUrl: String, path: String): String {
                            return baseUrl.removeSuffix("/") + "/" + path.removePrefix("/")
                        }
                    }

                    @OptIn(ExperimentalResourceApi::class)
                    class UploadViewModel(
                        private val coroutineScope: CoroutineScope,
                    ) {
                        val state = MutableStateFlow<UploadState>(UploadState.Idle)

                        val exceptionHandler = CoroutineExceptionHandler{_, throwable ->
                            state.value = UploadState.Error(throwable.message ?: "Unknown error")
                        }

                        fun upload() {
                            state.value = UploadState.Uploading

                            coroutineScope.launch(exceptionHandler) {
                                //request to worker through KCWClient
                                val kcwClient: KCWClient = KCWClient.create(
                                    KCWConfig(baseUrl = "")
                                )
                                kcwClient.uploadFile(
                                    path = "",
                                    contentType = "image/jpeg",
                                    byteArray = Res.readBytes("")
                                )
                                state.value = UploadState.Success
                            }
                        }
                    }

                    sealed interface UploadState {
                        data object Idle : UploadState
                        data object Uploading : UploadState
                        data object Success : UploadState
                        data class Error(val message: String) : UploadState
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    class NetworkClient(val httpClient: HttpClient) {
                        suspend inline fun <reified T> get(details: PokeApiRequestDetails): Result<T> {
                            return try {
                                val data = httpClient.get(details.path) {
                                    details.queries.forEach {
                                        parameter(it.key, it.value)
                                    }
                                }
                                val result = data.body<T>()
                                return Result.success(result)
                            } catch (e: Exception) {
                                Result.failure(e)
                            }
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "API Key Using DI",
                modifier = Modifier.fontSize(FontSize.Large).padding(bottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/MrWolfeDev/News-app-in-KMP
            //News API Key 4bcb23f7dc544a22917413ad24bc77fc
            KotlinCode(
                code = $$"""
                    expect fun createHttpClient(): HttpClient
                    
                    class NewsAPIServices(val apiKey: String) {
                        val client = HttpClient(CIO) { }
                    }
                    
                    //di
                    val networkModule = module {
                        single { NewsAPIServices(apiKey = "") }
                    }
                    
                    val repositoryModule = module {
                        single<NewsRepository>{ NewsRepositoryImpl(get()) }
                    }
                    
                    val sharedModules = listOf(networkModule, repositoryModule)
                    
                    //ViewModel
                    fun presentationModule(): Module = module {
                        // Since in Compose you use koinInject(), register it as a singleton (or factory if you prefer):
                        single { NewsViewModel(get()) }
                    }
                    
                    class NewsViewModel(
                        private val headlineUseCase: HeadlineRepositoryUseCase
                    ) : ViewModel() { }
                    
                    interface NewsRepository {
                        suspend fun getNewsByTopic(topic: String,sortBy: String): Result<NewsDTO>
                    }
                    
                    class NewsRepositoryImpl(
                        private val apiServices: NewsAPIServices
                    ) : NewsRepository {

                        override suspend fun getNewsByTopic(topic: String, sortBy: String): Result<NewsDTO> {
                            return try {
                                val response = withContext(Dispatchers.IO) {
                                    apiServices.client.get("/v2/everything") {
                                        parameter("q", topic)
                                        parameter("sortBy", sortBy)
                                        parameter("apiKey", apiServices.apiKey)
                                    }.body<NewsDTO>()
                                }
                                Result.Success(response)
                            } catch (e: RedirectResponseException) {
                                val body = e.response.bodyAsText()
                                Result.Error("Redirect (${e.response.status}): $body")
                            } catch (e: ClientRequestException) {
                                val body = e.response.bodyAsText()
                                Result.Error("Client error (${e.response.status}): $body")
                            } catch (e: ServerResponseException) {
                                val body = e.response.bodyAsText()
                                Result.Error("Server error (${e.response.status}): $body")
                            } catch (e: Exception) {
                                Result.Error("Unexpected error: ${e.message ?: e::class.simpleName}")
                            }
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Multiple Base URL",
                modifier = Modifier.fontSize(FontSize.Large).padding(bottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/droidwithme/product-catalog.git
            KotlinCode(
                code = """
                    private inline fun <reified T> HttpClient.requestFlow(
                        builder: HttpRequestBuilder = HttpRequestBuilder()
                    ) = flow {
                        HttpStatement(builder = builder, client = this@requestFlow)
                            .execute()
                            .body<T>()
                            .also { response -> emit(value = response) }
                    }

                    internal inline fun <reified T> HttpClient.getFlow(builder: HttpRequestBuilder) =
                        requestFlow<T>(builder = builder.apply { method = HttpMethod.Get })

                    internal inline fun <reified T> HttpClient.getFlow(
                        block: HttpRequestBuilder.() -> Unit = {}
                    ): Flow<T> = getFlow(builder = HttpRequestBuilder().apply(block = block))
                    
                    //DataModule.kt
                    internal val dataModule = module {
                        single {
                            HttpClient {
                                install(HttpCache)
                                install(ContentNegotiation) {
                                    json(
                                        json = Json {
                                            ignoreUnknownKeys = true
                                            prettyPrint = true
                                            isLenient = true
                                        }
                                    )
                                }
                                install(Logging) {
                                    logger = Logger.SIMPLE
                                    level = LogLevel.ALL
                                }
                            }
                        }

                        single<GetProductRepository> {
                            GetProductRepoImpl(client = get())
                        }

                        single<GetProductDetailsRepository> {
                            GetProductDetailsRepoImpl(client = get())
                        }
                    }
                    
                    //GetProductRepository.kt
                    public interface GetProductRepository {
                        public fun getProducts(
                            limit: Int,
                            skip: Int
                        ): Flow<PaginatedData<Products>>

                        public fun searchProducts(query: String): Flow<PaginatedData<Products>>
                    }
                    
                    //GetProductRepoImpl.kt
                    public class GetProductRepoImpl(private val client: HttpClient) : GetProductRepository {
                        override fun getProducts(
                            limit: Int,
                            skip: Int
                        ): Flow<PaginatedData<Products>> = client.getFlow<ProductsPaginatedScheme> {
                            url(scheme = "https", host = "dummyjson.com", path = "/products") {
                                parameter(key = "limit", value = limit)
                                parameter(key = "skip", value = skip)
                            }
                        }.map(ProductsPaginatedScheme::toDomain)

                        override fun searchProducts(query: String): Flow<PaginatedData<Products>> = client.getFlow<ProductsPaginatedScheme> {
                            url(scheme = "https", host = "dummyjson.com", path = "/products/search") {
                                parameter(key = "q", value = query)
                            }
                        }.map(ProductsPaginatedScheme::toDomain)
                    }
                    
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //https://github.com/NadaFeteiha/WeatherDesktopApp
                    //https://github.com/matthieucoisne/YelpExplorer-CMP (HttpClient and GraphQL)

                    import io.ktor.client.*
                    import io.ktor.client.engine.cio.*
                    import io.ktor.client.plugins.*
                    import io.ktor.client.plugins.contentnegotiation.*
                    import io.ktor.client.plugins.logging.*
                    import io.ktor.client.request.*
                    import io.ktor.http.*
                    import io.ktor.serialization.kotlinx.json.*
                    import io.ktor.util.*
                    import kotlinx.serialization.json.Json

                    object WeatherServiceClient {

                        val clientAttributes = Attributes(true)

                        val client = HttpClient(CIO) {
                            expectSuccess = true
                            install(Logging) {
                                logger = Logger.DEFAULT
                                level = LogLevel.ALL
                            }

                            defaultRequest {
                                when (clientAttributes[AttributeKey<String>("API")]) {
                                    APIS.WEATHER_API.value -> {
                                        url("http://api.weatherapi.com/v1/")
                                        header(HttpHeaders.ContentType, "application/json")
                                        url.parameters.append("key", "3aed1336391c477ea48154514230907")
                                    }
                                    APIS.LOCATION_API.value -> {
                                        url("http://apiip.net/api/")
                                        url.parameters.append("accessKey", "633cc30c-cdd9-4a91-bd9c-a76885121aa5")
                                    }
                                }
                            }

                            install(ContentNegotiation) {
                                json(
                                    Json {
                                        isLenient = true
                                        ignoreUnknownKeys = true
                                    }
                                )
                            }
                        }
                    }

                    enum class APIS(val value: String) {
                        LOCATION_API("LOCATION_API"),
                        WEATHER_API("WEATHER_API"),
                    }

                    interface WeatherService {
                        suspend fun getWeatherByCityName(city: String, numDays: Int = 10): Weather
                        suspend fun searchWeatherByCityName(city: String): List<SearchItem>
                        suspend fun getLocation(): LocationFromIP
                    }

                    class WeatherServiceImpl(private val client: HttpClient) : WeatherService {

                        override suspend fun getWeatherByCityName(city: String, numDays: Int) =
                            tryToExecute<Weather>(APIS.WEATHER_API, "forecast.json?q=ahmedabad&days=5") { get(it) }

                        override suspend fun getLocation(): LocationFromIP =
                            tryToExecute(APIS.LOCATION_API, "check") { get(it) }

                        override suspend fun searchWeatherByCityName(city: String): List<SearchItem> =
                            tryToExecute(APIS.WEATHER_API, "search.json?q=ahmedabad") { get(it) }

                        private suspend inline fun <reified T> tryToExecute(
                            api: APIS,
                            urlString: String,
                            method: HttpClient.(urlString: String) -> HttpResponse
                        ): T {
                            try {
                                WeatherServiceClient.clientAttributes.put(AttributeKey("API"), api.value)
                                val response = client.method(urlString)
                                return response.body()
                            } catch (e: Throwable) {
                                throw e
                            }
                        }
                    }

                    //di
                    val serviceModule = module {
                        single { WeatherServiceClient.client }
                    }

                    val appModules = module {
                        includes(
                            serviceModule
                        )
                        single<WeatherService> { WeatherServiceImpl(get()) }
                        //singleOf(::HomeViewModel) { bind() }
                    }

                    fun initKoin(appDeclaration: KoinAppDeclaration = {}) = startKoin {
                        appDeclaration()
                        modules(
                            appModules
                        )
                    }
                    """.trimIndent()
            )

            //https://github.com/MarketTwits/Sportsouce.git
            KotlinCode(
                code = """
                    //di 
                    val teamsCityModule = module {
                        single<SportSauceNetworkTeamsCityApi> {
                            SportSauceNetworkTeamsCityApi(
                                HttpClientProviderBase(
                                    json = JsonProviderBase().provide(),
                                    baseUrl = BuildKonfig.SPORTSAUCE_API_PATH
                                )
                            )
                        }
                    }
                    
                    val clubCloudModule = module {
                        singleOf(::SportSauceClubsNetworkApiBase) bind SportSauceClubsNetworkApi::class
                        factory<HttpClientProvider> {
                            SportSauceHttpClientProvider()
                        }
                    }
                    
                    val sportSauceStartNetworkModule = module {
                        single<SportSauceStartRegisterApi> {
                            SportSauceStartRegisterApiBase(get(named(HTTP_CLIENT_PROVIDER_SCOPE_ID)))
                        }
                        
                        single<HttpClientProvider>(named(HTTP_CLIENT_PROVIDER_SCOPE_ID)) {
                            SportSauceHttpClientProvider()
                        }
                    }

                    internal const val HTTP_CLIENT_PROVIDER_SCOPE_ID = ""
                    
                    class JsonProviderBase : JsonProvider {
                        override fun provide(): Json =
                            Json {
                                isLenient = true
                                ignoreUnknownKeys = true
                                useAlternativeNames = false
                            }
                    }
                    
                    //val json = JsonProvider().provide()
                    //val user = json.decodeFromString<User>()
                      
                    class HttpClientProviderBase(
                        private val json: Json,
                        private val baseUrl: String,
                    ) : HttpClientProvider {

                        override fun provide(loggerEnabled: Boolean) = HttpClient {
                            expectSuccess = true
                            install(ContentNegotiation) {
                                json(json)
                            }
                            if (loggerEnabled) {
                                install(Logging) {
                                    logger = Logger.DEFAULT
                                    level = LogLevel.ALL
                                }
                            }
                            install(HttpTimeout) {
                                requestTimeoutMillis = 30000
                                connectTimeoutMillis = 30000
                                socketTimeoutMillis = 30000
                            }
                            defaultRequest {
                                header(HttpHeaders.ContentType, ContentType.Application.Json)
                                url.takeFrom(
                                    URLBuilder()
                                        .takeFrom(baseUrl)
                                        .apply { encodedPath += url.encodedPath }
                                )
                            }
                        }

                        override fun json(): Json = json
                    }

                    fun SportSauceHttpClientProvider(
                        baseUrl: String = SportSauceBaseUrl,
                        json: Json = JsonProviderBase().provide(),
                    ) : HttpClientProvider {
                        return HttpClientProviderBase(
                            json = json,
                            baseUrl = baseUrl,
                        )
                    }

                    val SportSauceBaseUrl = BuildKonfig.SPORTSAUCE_API_PATH
                   
                    interface SportSauceClubsNetworkApi {
                        suspend fun trainers(): List<TrainersRemoteRow>
                    }
                    
                    internal class SportSauceClubsNetworkApiBase(
                       httpClient: HttpClientProvider
                    ) : SportSauceClubsNetworkApi {

                        private val json = httpClient.json()

                        private val client = httpClient.provide(true)

                        override suspend fun trainers(): List<TrainersRemoteRow> {
                            val response = client.get("trainer")
                            return json.decodeFromString<TrainersRemote>(response.body<String>()).rows
                        }
                    }
                    
                    class SportSauceStartRegisterApiBase(httpClient: HttpClientProvider) : SportSauceStartRegisterApi {
                        private val json = httpClient.json()
                        private val client = httpClient.provide(true)
                    }
                    
                    
                    internal class SportSauceNetworkTeamsCityApi(
                        httpClient: HttpClientProvider
                    ) {
                        private val json = httpClient.json()

                        private val client = httpClient.provide(true)

                        suspend fun teams(): NetworkTeams {
                            val response = client.get("team")
                            return json.decodeFromString(response.body<String>())
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Multiple Interceptor",
                modifier = Modifier.fontSize(FontSize.Large).padding(bottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    import io.ktor.client.HttpClient
                    import io.ktor.client.engine.okhttp.OkHttp
                    import io.ktor.client.plugins.DefaultRequest
                    import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
                    import io.ktor.client.plugins.logging.LogLevel
                    import io.ktor.client.plugins.logging.Logger
                    import io.ktor.client.plugins.logging.Logging
                    import io.ktor.client.plugins.observer.ResponseObserver
                    import io.ktor.client.request.header
                    import io.ktor.http.ContentType
                    import io.ktor.http.HttpHeaders
                    import io.ktor.serialization.kotlinx.json.json
                    import kotlinx.serialization.ExperimentalSerializationApi
                    import kotlinx.serialization.json.Json
                    import okhttp3.Interceptor
                    import timber.log.Timber
                    import java.util.concurrent.TimeUnit

                    private const val CONNECT_TIMEOUT = 15L
                    private const val READ_TIMEOUT = 60L
                    private const val WRITE_TIMEOUT = 15L

                    // ktor http client
                    @OptIn(ExperimentalSerializationApi::class)
                    val ktorHttpClient: (List<Interceptor>) -> HttpClient = { interceptors ->
                        HttpClient(OkHttp) {
                            expectSuccess = true

                            // okhttp engine config
                            engine {
                                config {
                                    connectTimeout(CONNECT_TIMEOUT, TimeUnit.SECONDS)
                                    writeTimeout(WRITE_TIMEOUT, TimeUnit.SECONDS)
                                    readTimeout(READ_TIMEOUT, TimeUnit.SECONDS)

                                    interceptors.forEach {
                                        addInterceptor(it)
                                    }
                                }
                            }

                            // kotlinx serialization
                            install(ContentNegotiation) {
                                json(
                                    Json {
                                        prettyPrint = true
                                        isLenient = true
                                        ignoreUnknownKeys = true
                                        explicitNulls = false
                                    }
                                )
                            }

                            // ktor logger
                            install(Logging) {
                                level = LogLevel.ALL
                                logger = object : Logger {
                                    override fun log(message: String) = Timber.tag("Ktor logger:").v(message)
                                }
                            }

                            // ktor response observer
                            install(ResponseObserver) {
                                onResponse { response ->
                                    Timber.tag("HTTP status:").d("response.status.value")
                                }
                            }

                            // request content-type
                            install(DefaultRequest) {
                                header(HttpHeaders.ContentType, ContentType.Application.Json)
                            }
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    import android.content.Context
                    import com.chuckerteam.chucker.api.ChuckerCollector
                    import com.chuckerteam.chucker.api.ChuckerInterceptor
                    import com.chuckerteam.chucker.api.RetentionManager
                    import dagger.Module
                    import dagger.Provides
                    import dagger.hilt.InstallIn
                    import dagger.hilt.android.qualifiers.ApplicationContext
                    import dagger.hilt.components.SingletonComponent
                    import io.ktor.client.HttpClient
                    import javax.inject.Singleton

                    @Module
                    @InstallIn(SingletonComponent::class)
                    object NetworkModule {

                        @Provides
                        @Singleton
                        fun provideChuckerInterceptor(@ApplicationContext context: Context): ChuckerInterceptor {

                            // Create the Collector
                            val chuckerCollector = ChuckerCollector(
                                context = context,
                                showNotification = true,
                                retentionPeriod = RetentionManager.Period.ONE_HOUR
                            )

                            // Create the Interceptor
                            return ChuckerInterceptor.Builder(context)
                                .collector(chuckerCollector)
                                .maxContentLength(250_000L)
                                .redactHeaders("Auth-Token", "Bearer")
                                .alwaysReadResponseBody(true)
                                .createShortcut(true)
                                .build()
                        }

                        @Provides
                        @Singleton
                        fun provideKtorClient(
                            authTokenInterceptor: AuthTokenInterceptor,
                            chuckerInterceptor: ChuckerInterceptor,
                        ): HttpClient {
                            return ktorHttpClient(listOf(authTokenInterceptor, chuckerInterceptor))
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    import okhttp3.Interceptor
                    import okhttp3.Response
                    import javax.inject.Inject

                    class AuthTokenInterceptor @Inject constructor() : Interceptor {
                        override fun intercept(chain: Interceptor.Chain): Response {

                            val requestBuilder = chain.request().newBuilder()
                            requestBuilder.addHeader("Authorization", "Bearer Token Add")
                            val newRequest = requestBuilder.build()
                            return chain.proceed(newRequest)
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "API Calling 1",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    //di.kt

                    import com.app.pixabay.core.util.resultOf
                    import io.ktor.client.HttpClient
                    import io.ktor.client.call.body
                    import io.ktor.client.request.HttpRequestBuilder
                    import io.ktor.client.request.get
                    import io.ktor.client.request.post
                    import io.ktor.client.statement.HttpResponse
                    import io.ktor.http.isSuccess

                    suspend inline fun <reified T> Result<HttpResponse>.receiveResult(): Result<T> {
                        return this.mapCatching {
                            if (it.status.isSuccess()) {
                                val data = it.body<T>()
                                data
                            } else {
                                val data = it.body<ErrorModel>()
                                throw Exception(data.detail ?: "")
                            }
                        }
                    }

                    suspend fun HttpClient.get(block: HttpRequestBuilder.() -> Unit): Result<HttpResponse> = resultOf { get(HttpRequestBuilder().apply(block)) }

                    suspend fun HttpClient.post(block: HttpRequestBuilder.() -> Unit): Result<HttpResponse> =
                        resultOf { post(HttpRequestBuilder().apply(block)) }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //ErrorModel.kt

                    import kotlinx.serialization.SerialName
                    import kotlinx.serialization.Serializable

                    @Serializable
                    data class ErrorModel(
                        @SerialName("detail")
                        val detail: String? = null,
                        @SerialName("message")
                        val message: String? = null,
                        @SerialName("path")
                        val path: String? = null,
                        @SerialName("status")
                        val status: Int? = null,
                        @SerialName("title")
                        val title: String? = null,
                        @SerialName("type")
                        val type: String? = null,
                    )
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //KtorApi.kt

                    import io.ktor.client.HttpClient
                    import io.ktor.client.request.HttpRequestBuilder

                    interface KtorApi {
                        val client: HttpClient
                        fun HttpRequestBuilder.apiUrl(path: String)
                        fun HttpRequestBuilder.json()
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //KtorApiImpl.kt

                    import io.ktor.client.HttpClient
                    import io.ktor.client.plugins.HttpTimeout
                    import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
                    import io.ktor.client.plugins.logging.LogLevel
                    import io.ktor.client.plugins.logging.Logger
                    import io.ktor.client.plugins.logging.Logging
                    import io.ktor.client.plugins.logging.SIMPLE
                    import io.ktor.client.request.HttpRequestBuilder
                    import io.ktor.http.ContentType
                    import io.ktor.http.contentType
                    import io.ktor.http.encodedPath
                    import io.ktor.http.takeFrom
                    import io.ktor.serialization.kotlinx.json.json
                    import kotlinx.serialization.json.Json

                    class KtorApiImpl : KtorApi {
                        private val baseURl = "https://pixabay.com/"

                        override val client =
                            HttpClient {

                                install(ContentNegotiation) {
                                    json(
                                        Json {
                                            prettyPrint = true
                                            isLenient = true
                                            ignoreUnknownKeys = true
                                        },
                                    )
                                }

                                install(Logging) {
                                    logger = Logger.SIMPLE
                                    level = LogLevel.ALL
                                }

                                install(HttpTimeout) {
                                    requestTimeoutMillis = 30_000
                                    connectTimeoutMillis = 30_000
                                    socketTimeoutMillis = 30_000
                                    
                                    //requestTimeoutMillis = 20_000L
                                }
                            }

                        override fun HttpRequestBuilder.apiUrl(path: String) {
                            url {
                                takeFrom(baseURl)
                                encodedPath = path
                            }
                        }

                        override fun HttpRequestBuilder.json() {
                            contentType(ContentType.Application.Json)
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //KtorEXT.kt

                    import io.ktor.client.HttpClient
                    import io.ktor.client.call.body
                    import io.ktor.client.request.HttpRequestBuilder
                    import io.ktor.client.request.get
                    import io.ktor.client.request.post
                    import io.ktor.client.statement.HttpResponse
                    import io.ktor.http.isSuccess

                    suspend inline fun <reified T> Result<HttpResponse>.receiveResult(): Result<T> {
                        return this.mapCatching {
                            if (it.status.isSuccess()) {
                                val data = it.body<T>()
                                data
                            } else {
                                val data = it.body<ErrorModel>()
                                throw Exception(data.detail ?: "")
                            }
                        }
                    }

                    suspend fun HttpClient.get(block: HttpRequestBuilder.() -> Unit): Result<HttpResponse> = resultOf { get(HttpRequestBuilder().apply(block)) }

                    suspend fun HttpClient.post(block: HttpRequestBuilder.() -> Unit): Result<HttpResponse> =
                        resultOf { post(HttpRequestBuilder().apply(block)) }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Mapper.kt

                    fun interface Mapper<I, O> : (I) -> O
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //ResultOf.kt

                    import kotlinx.coroutines.CancellationException
                    import kotlinx.coroutines.TimeoutCancellationException

                    inline fun <R> resultOf(block: () -> R): Result<R> {
                        return try {
                            Result.success(block())
                        } catch (t: TimeoutCancellationException) {
                            Result.failure(t)
                        } catch (c: CancellationException) {
                            throw c
                        } catch (e: Exception) {
                            Result.failure(e)
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                   private val searchApi =
                    module {
                        single { SearchApi(get()) }
                    }

                    class SearchApi(private val api: KtorApi) : KtorApi by api {
                        suspend fun search(query: String): Result<SearchResultDataModel> {
                            return client.get {
                                apiUrl("")
                                json()
                            }.receiveResult<SearchResultDataModel>()
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Dispatchers.kt

                    import kotlinx.coroutines.CoroutineDispatcher
                    import kotlinx.coroutines.Dispatchers
                    import kotlinx.coroutines.IO
                    import org.koin.core.qualifier.named
                    import org.koin.dsl.module

                    const val ioDispatcher: String = "IODispatcher"
                    const val mainDispatcher: String = "mainDispatcher"

                    val dispatchersModule =
                        module {
                            single<CoroutineDispatcher>(named(ioDispatcher)) {
                                Dispatchers.IO
                            }

                            single<CoroutineDispatcher>(named(mainDispatcher)) {
                                Dispatchers.Main
                            }
                        }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    fun initKoin(appDeclaration: KoinAppDeclaration) =
                        startKoin {
                            appDeclaration()
                            modules(
                                ktorProvider,
                                dispatchersModule,
                            )
                        }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    import org.koin.core.qualifier.Qualifier
                    import org.koin.core.qualifier.named

                    enum class KtorfitConfig(val qualifier: Qualifier, val baseUrl: String) {
                        OpenWeather(
                            qualifier = named("openWeatherKtorfit"),
                            baseUrl = "https://api.openweathermap.org/data/2.5/");

                        fun findByQualifierName(qualifierName: String): KtorfitConfig? {
                            return entries.find { it.qualifier == named(qualifierName) }
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    import io.ktor.client.HttpClient
                    import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
                    import io.ktor.client.plugins.logging.LogLevel
                    import io.ktor.client.plugins.logging.Logger
                    import io.ktor.client.plugins.logging.Logging
                    import io.ktor.serialization.kotlinx.json.json
                    import kotlinx.serialization.json.Json
                    import org.koin.dsl.module

                    val infrastructureModule = module {
                        includes(
                            apiModule,
                            repositoryModule,
                        )

                        single<HttpClient> {
                            HttpClient {
                                engine {}
                                install(ContentNegotiation) {
                                    json(
                                        Json {
                                            encodeDefaults = true
                                            isLenient = true
                                            allowSpecialFloatingPointValues = true
                                            allowStructuredMapKeys = true
                                            prettyPrint = false
                                            useArrayPolymorphism = false
                                            ignoreUnknownKeys = true
                                        }
                                    )
                                }
                                install(Logging) {
                                    logger = object : Logger {
                                        override fun log(message: String) {

                                        }
                                    }
                                    level = LogLevel.ALL
                                }
                            }
                        }

                        single<Ktorfit>(qualifier = KtorfitConfig.OpenWeather.qualifier) {
                            Ktorfit.Builder()
                                .httpClient(client = get())
                                .baseUrl(KtorfitConfig.OpenWeather.baseUrl)
                                .build()
                        }
                    }

                    val apiModule = module {
                        single<OpenWeatherApi> { get<Ktorfit>(KtorfitConfig.OpenWeather.qualifier).create() }
                    }

                    val repositoryModule = module {
                        single<WeatherRepository> { WeatherRepositoryImpl(openWeatherApi = get()) }
                    }

                    //ViewModelModule.kt
                    import org.koin.core.module.Module

                    expect val viewModelModule: Module

                    //PresentationModule.kt
                    import org.koin.dsl.module

                    val presentationModule = module {
                        includes(
                            viewModelModule,
                        )
                    }

                    //iosMain
                    import org.koin.core.module.dsl.singleOf
                    import org.koin.dsl.module

                    actual val viewModelModule = module {
                        singleOf(::AppViewModel)
                        singleOf(::HomeViewModel)
                        singleOf(::SearchViewModel)
                    }

                    //androidMain
                    import org.koin.androidx.viewmodel.dsl.viewModelOf
                    import org.koin.dsl.module

                    actual val viewModelModule = module {
                        viewModelOf(::AppViewModel)
                        viewModelOf(::HomeViewModel)
                        viewModelOf(::SearchViewModel)
                    }

                    val sharedAppDIContainer = module {
                        includes(
                            infrastructureModule,
                            domainModule,
                            presentationModule,
                        )
                    }

                    import org.koin.dsl.module

                    val domainModule = module {
                        includes(
                            useCaseModule,
                        )
                    }

                    //iosMain
                    actual class KoinInitializer {
                        actual fun init() {
                            startKoin {
                                modules(sharedAppDIContainer)
                            }
                        }
                    }

                    //androidMain
                    import android.content.Context
                    import org.koin.android.ext.koin.androidContext
                    import org.koin.android.ext.koin.androidLogger
                    import org.koin.core.context.startKoin

                    actual class KoinInitializer(
                        private val context: Context,
                    ) {
                        actual fun init() {
                            startKoin {
                                androidContext(context)
                                androidLogger()
                                modules(
                                    sharedAppDIContainer
                                )
                            }
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "API Calling 2",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    //DI

                    private val coreModule = module {
                        single {
                            Json {
                                isLenient = true
                                prettyPrint = true
                                ignoreUnknownKeys = true
                            }
                        }

                        single {
                            KmmAppKtorClient(get(), get())
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    import io.github.aakira.napier.Napier
                    import io.ktor.client.call.body
                    import io.ktor.client.request.forms.FormBuilder
                    import io.ktor.client.request.forms.MultiPartFormDataContent
                    import io.ktor.client.request.forms.formData
                    import io.ktor.client.request.get
                    import io.ktor.client.request.headers
                    import io.ktor.client.request.parameter
                    import io.ktor.client.request.post
                    import io.ktor.client.request.put
                    import io.ktor.client.request.setBody
                    import io.ktor.client.statement.HttpResponse
                    import io.ktor.client.statement.bodyAsText
                    import io.ktor.http.ContentType
                    import io.ktor.http.HeadersBuilder
                    import io.ktor.http.contentType
                    import kotlinx.serialization.json.Json

                    suspend inline fun KmmAppKtorClient.submitFormWithData(
                        url: String,
                        noinline headers: HeadersBuilder.() -> Unit = {},
                        noinline formData: FormBuilder.() -> Unit
                    ) = runCatching {
                        instance().post(url) {
                            headers(headers)
                            setBody(MultiPartFormDataContent(formData(formData)))
                        }
                    }

                    suspend inline fun <reified T> KmmAppKtorClient.submitWithBody(
                        url: String, noinline headers: HeadersBuilder.() -> Unit = {}, body: T
                    ) = runCatching {
                        instance().post(url) {
                            contentType(ContentType.Application.Json)
                            headers(headers)
                            setBody(body)
                        }
                    }

                    suspend inline fun <reified T> KmmAppKtorClient.submitWithBodyAndAuthHeader(
                        url: String, noinline headers: HeadersBuilder.() -> Unit, body: T
                    ) = runCatching {
                        client.post(url) {
                            contentType(ContentType.Application.Json)
                            headers(headers)
                            setBody(body)
                        }
                    }

                    suspend inline fun KmmAppKtorClient.get(
                        url: String, noinline headers: HeadersBuilder.() -> Unit = {}, vararg params: Pair<String, Any>
                    ) = runCatching {
                        instance().get(url) {
                            headers(headers)
                            params.forEach {
                                parameter(it.first, it.second)
                            }
                        }
                    }

                    suspend inline fun KmmAppKtorClient.getWithAuthHeaders(
                        url: String, noinline authHeaders: HeadersBuilder.() -> Unit = {}
                    ) = runCatching {
                        client.get(url) {
                            headers(authHeaders)
                        }
                    }

                    suspend inline fun KmmAppKtorClient.put(
                        url: String, noinline headers: HeadersBuilder.() -> Unit = {}, vararg params: Pair<String, Any>

                    ) = runCatching {
                        instance().put(url) {
                            headers(headers)
                            params.forEach {
                                parameter(it.first, it.second)
                            }
                        }
                    }

                    private val json = Json {
                        ignoreUnknownKeys = true
                        isLenient = true
                        prettyPrint = true
                    }

                    suspend fun Result<HttpResponse>.toResult(): NetworkResult {
                        return when {
                            isSuccess -> getOrThrow().run {

                                when (this.status.value) {
                                    200, 201, 202, 204, 205 -> {
                                        NetworkResult.Success(body())
                                    }

                                    400 -> {
                                        val errorBody: ApiWrapper<String?> = json.decodeFromString(bodyAsText())
                                        val errorMessage = errorBody.response ?: errorBody.message
                                        NetworkResult.Error(
                                            NetworkException(
                                                errorMessage ?: "Something went wrong! Please try again later."
                                            )
                                        )
                                    }

                                    401 -> {
                                        val errorBody: ApiWrapper<String?> = json.decodeFromString(bodyAsText())
                                        val errorMessage = errorBody.response ?: errorBody.message
                                        NetworkResult.Error(
                                            NetworkException(
                                                errorMessage ?: "Authorization Failed! Try Logging In again."
                                            )
                                        )
                                    }

                                    in listOf(500, 503) -> {
                                        val errorBody: ApiWrapper<String?> = json.decodeFromString(bodyAsText())
                                        val errorMessage = errorBody.response ?: errorBody.message
                                        NetworkResult.Error(
                                            NetworkException(
                                                errorMessage ?: "Server Disruption! We are on fixing it."
                                            )
                                        )
                                    }

                                    504 -> {
                                        val errorBody: ApiWrapper<String?> = json.decodeFromString(bodyAsText())
                                        val errorMessage = errorBody.response ?: errorBody.message
                                        NetworkResult.Error(
                                            NetworkException(
                                                errorMessage ?: "Too much load at this time, try again later!"
                                            )
                                        )
                                    }

                                    else -> {
                                        val errorBody: ApiWrapper<String?> = json.decodeFromString(bodyAsText())
                                        val errorMessage = errorBody.response ?: errorBody.message
                                        NetworkResult.Error(
                                            NetworkException(
                                                errorMessage ?: "Something went wrong! Please try again later."
                                            )
                                        )
                                    }
                                }
                            }

                            else -> {
                                this.exceptionOrNull()?.printStackTrace()
                                NetworkResult.Error(KtorException("Something went wrong! Please try again later."))
                            }
                        }
                    }

                    class NetworkException(message: String) : Exception(message)
                    class KtorException(message: String) : Exception(message)

                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    import kotlinx.serialization.Serializable

                    @Serializable
                    data class ApiWrapper<T>(
                        val message: String? = null,
                        val response: T? = null,
                        val status: String? = null
                    )

                    sealed interface NetworkResult {
                        data class Success(val data: ByteArray) : NetworkResult {
                            override fun equals(other: Any?): Boolean {
                                if (this === other) return true
                                if (other == null || this::class != other::class) return false

                                other as Success
                                return data.contentEquals(other.data)
                            }

                            override fun hashCode(): Int {
                                return data.contentHashCode()
                            }
                        }

                        data class Error(val error: Exception) : NetworkResult
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    interface HomeApi {
                        suspend fun getCoins(): NetworkResult
                    }

                    class HomeApiImpl(
                        private val client: KmmAppKtorClient
                    ) : HomeApi {
                        override suspend fun getCoins(): NetworkResult {
                            val params = arrayOf(
                                "vs_currency" to "usd",
                                "order" to "market_cap_desc",
                                "per_page" to 100,
                                "page" to 1,
                                "sparkline" to true,
                                "price_change_percentage" to "24h"
                            )

                            return client.get("https://api.coingecko.com/api/v3/coins/markets", params = params)
                                .toResult()
                        }
                    }

                    interface HomeRepository {
                        suspend fun getCoins(): List<Coin>
                    }

                    class HomeRepositoryImpl(
                        private val api: HomeApi,
                        private val json: Json
                    ) : HomeRepository {
                        override suspend fun getCoins(): List<Coin> {
                            return when (val result = api.getCoins()) {
                                is NetworkResult.Error -> throw result.error
                                is NetworkResult.Success -> json.toObject<List<Coin>>(result.data.decodeToString())
                            }
                        }
                    }

                    interface CoinsUseCase : suspend () -> Either<List<Coin>>

                    class  CoinsUseCaseImpl constructor(
                        private val repo: HomeRepository
                    ) :  CoinsUseCase {
                        override suspend fun invoke(): Either<List<Coin>> = runCatching {
                            val response = repo.getCoins()
                            Either.Success(response)
                        }.getOrElse {
                            Either.Error(it.message ?: "Something went wrong!")
                        }
                    }

                    //viewmodel
                     when (val result = coinsUseCase()) {
                        is Either.Error -> {
                            //v
                        }

                        is Either.Success -> {
                            //result.data
                            updateState(newState = state.value.copy(allCoins = result.data))
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Download File

                    suspend fun requestByteArray(
                        url: String,
                        onDownload: suspend (bytesSentTotal: Long, contentLength: Long) -> Unit = { _: Long, _: Long ->}
                    ): ByteArray?
                    {
                        return try
                        {
                            client.get(url) {
                                onDownload { bytesSentTotal, contentLength -> onDownload(bytesSentTotal, contentLength) }
                            }
                                .debug { println(it) }
                                .checkLimit()
                                .bodyIfOK()
                        }
                        catch (e: Exception)
                        {
                            println(e.printStackTrace())
                            null
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //HttpRequestBuilder

                    @Suppress("FunctionNaming")
                    internal fun POST(
                      url: String,
                      body: String,
                      headers: Headers = Headers.Empty,
                      contentType: ContentType = ContentType.Application.Json,
                    ): HttpRequestBuilder {
                      return HttpRequestBuilder()
                        .apply {
                          this.method = HttpMethod.Post
                          this.url.set { takeFrom(url) }
                          this.headers.appendAll(headers)
                          this.setBody(body)
                          contentType(contentType)
                        }
                    }

                    class ProgressApi(
                      private val client: HttpClient,
                    ) {
                      suspend fun login(id: String, password: String): UserAuth {
                        return client.request(
                          POST(Endpoints.Login.buildUrl(), body = "")).body<UserAuth>()
                      }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //kotlinx.serialization with check the model class convert String to JSON
                    //https://github.com/L0LB0Y/HackerNews-KMP

                    import io.github.aakira.napier.Napier
                    import io.ktor.client.statement.HttpResponse
                    import io.ktor.client.statement.bodyAsText
                    import kotlinx.coroutines.Dispatchers
                    import kotlinx.coroutines.IO
                    import kotlinx.coroutines.withContext
                    import kotlinx.serialization.KSerializer
                    import kotlinx.serialization.json.Json

                    /**
                     * Handler to run API requests.
                     */
                    object ApiHandler {
                        /**
                         * Run a suspend block and return the response body as a string.
                         */
                        suspend fun run(
                            block: suspend () -> HttpResponse
                        ): Result<String> = withContext(Dispatchers.IO) {
                            try {
                                val result = block()
                                if (result.status.value in 200..299) {
                                    Result.success(result.bodyAsText())
                                } else {
                                    Result.failure(UnknownError)
                                }
                            } catch (exception: Exception) {
                                Napier.e(exception.message ?: "Failed to fetch data", exception)
                                Result.failure(NetworkError)
                            }
                        }

                        /**
                         * Run a suspend block and parse the response body to a type.
                         */
                        suspend fun <T> runAndParse(
                            json: Json,
                            type: KSerializer<T>,
                            block: suspend () -> HttpResponse
                        ): Result<T> {
                            val result = run(block)
                            return if (result.isSuccess) {
                                try {
                                    Result.success(json.decodeFromString(type, result.getOrThrow()))
                                } catch (exception: Exception) {
                                    Napier.e(exception.message ?: "Failed to parse data", exception)
                                    Result.failure(ParseError)
                                }
                            } else {
                                Result.failure(result.exceptionOrNull() ?: UnknownError)
                            }
                        }
                    }

                    sealed class AppError(override val message: String) : Throwable(message)
                    data object NetworkError : AppError("No network connection.")
                    data object UnknownError : AppError("Something went wrong.")
                    data object ParseError : AppError("Failed to parse data.")

                    sealed class Category(val path: String, val index: Int, val title: String) {
                        companion object {
                            fun from(spinnerIndex: Int): Category = when (spinnerIndex) {
                                0 -> TopStories
                                1 -> NewStories
                                2 -> BestStories
                                3 -> AskStories
                                4 -> ShowStories
                                5 -> JobStories
                                else -> throw IllegalArgumentException("Invalid index")
                            }

                            fun getAll(): List<Category> = listOf(
                                TopStories, NewStories, BestStories, AskStories, ShowStories, JobStories
                            )
                        }
                    }

                    data object TopStories : Category("topstories.json", 0, "Top Stories")
                    data object NewStories : Category("newstories.json", 1, "New Stories")
                    data object BestStories : Category("beststories.json", 2, "Best Stories")
                    data object AskStories : Category("askstories.json", 3, "Ask Stories")
                    data object ShowStories : Category("showstories.json", 4, "Show Stories")
                    data object JobStories : Category("jobstories.json", 5, "Job Stories")

                    //USE
                    Category.getAll()
                    Category.from(category.index)

                    interface ItemRepository {
                        suspend fun fetchItems(ids: List<Long>): List<Result<Item?>>
                        suspend fun fetchStories(category: Category): Result<List<Long>>
                        suspend fun fetchComments(depth:Int, ids: List<Long>): Flow<Result<Comment>>
                    }

                    class ItemRepositoryImpl(
                        private val client: HttpClient,
                        private val json: Json,
                        private val apiHandler: ApiHandler
                    ) : ItemRepository {
                        override suspend fun fetchItems(ids: List<Long>): List<Result<Item?>> = coroutineScope {
                            ids.map { async { fetchItem(it) } }.awaitAll()
                        }

                        private suspend fun fetchItem(id: Long): Result<Item?> {
                            val result = apiHandler.run { client.get("") }
                            return if (result.isSuccess) {
                                Result.success(Item.from(json, result.getOrThrow()))
                            } else {
                                Result.failure(result.exceptionOrNull()!!)
                            }
                        }

                        override suspend fun fetchStories(category: Category): Result<List<Long>> =
                            apiHandler.runAndParse(json, ListSerializer(Long.serializer())) {
                                client.get("")
                            }

                        override suspend fun fetchComments(depth: Int, ids: List<Long>): Flow<Result<Comment>> = flow {
                            ids.forEach { id ->
                                val result = fetchItem(id)
                                if (result.isSuccess) {
                                    val comment = result.getOrThrow() as? Comment
                                    if (comment != null) {
                                        emit(Result.success(comment.copy(depth = depth)))
                                        if (comment.commentIds.isNotEmpty()) {
                                            fetchComments(depth + 1, comment.commentIds).collect { emit(it) }
                                        }
                                    }
                                } else {
                                    emit(Result.failure(result.exceptionOrNull()!!))
                                }
                            }
                        }

                        companion object {
                            private const val API_URL = "https://hacker-news.firebaseio.com/v0"
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //https://github.com/kaaneneskpc/Shopr

                    sealed class ResultWrapper<out T> {
                        data class Success<out T>(val value: T) : ResultWrapper<T>()
                        data class Failure(val exception: Exception) : ResultWrapper<Nothing>()
                    }

                    suspend inline fun <reified T, R> makeWebRequest(
                        url: String,
                        method: HttpMethod,
                        body: Any? = null,
                        headers: Map<String, String> = emptyMap(),
                        parameters: Map<String, String> = emptyMap(),
                        noinline mapper: ((T) -> R)? = null
                    ): ResultWrapper<R> {
                        return try {
                            val response = client.request(url) {
                                this.method = method
                                url {
                                    this.parameters.appendAll(Parameters.build {
                                        parameters.forEach { (key, value) ->
                                            append(key, value)
                                        }
                                    })
                                }
                                headers.forEach { (key, value) ->
                                    header(key, value)
                                }
                                if (body != null) {
                                    setBody(body)
                                }

                                contentType(ContentType.Application.Json)
                            }.body<T>()
                            val result: R = mapper?.invoke(response) ?: response as R
                            ResultWrapper.Success(result)
                        } catch (e: ClientRequestException) {
                            ResultWrapper.Failure(e)
                        } catch (e: ServerResponseException) {
                            ResultWrapper.Failure(e)
                        } catch (e: IOException) {
                            ResultWrapper.Failure(e)
                        } catch (e: Exception) {
                            ResultWrapper.Failure(e)
                        }
                    }
                """".trimIndent()
            )

            //https://github.com/fasanchez87/KMPMovies
            KotlinCode(
                code = """
//HttpResponseValidator KTOR
val networkModule =
    module {
        single<HttpClient> {
            HttpClient {
                install(ContentNegotiation) {
                    json(
                        Json {
                            prettyPrint = true
                            isLenient = true
                            ignoreUnknownKeys = true
                            allowStructuredMapKeys = true
                        },
                    )
                }
                install(DefaultRequest) {
                    url {
                        protocol = URLProtocol.HTTPS
                        host = get(named("baseHost"))
                        parameters.append("api_key", get(named("apiKey")))
                    }
                }
                install(Logging) {
                    level = LogLevel.ALL
                    logger =
                        object : Logger {
                            override fun log(message: String) {
                                println(message)
                            }
                        }
                }
                install(HttpTimeout) {
                    requestTimeoutMillis = 15_000
                }

                HttpResponseValidator {
                    validateResponse { response ->
                        if (!response.status.isSuccess()) {
                            throw handleHttpError(response.status.value)
                        }
                    }
                    handleResponseExceptionWithRequest { exception, _ ->
                        if (exception !is BaseHttpException) {
                            throw handleExceptionHttp(exception)
                        }
                    }
                }
            }
        }
    }

    fun handleHttpError(code: Int): Throwable =
        when (code) {
            401 -> UnauthorizedAccessException()
            else -> UnknownCodeHttpException()
        }

    fun handleExceptionHttp(throwable: Throwable): Exception =
        when (throwable) {
            is TimeoutCancellationException -> ErrorTimeoutException()
            is ClientRequestException -> ErrorRequestClientException()
            else -> UnknownCauseHttpException()
        }

    class ErrorTimeoutException : Exception() {
        override val message: String
            get() = "The request timed out. Please try again later."
    }

    class ErrorRequestClientException : Exception() {
        override val message: String
            get() = "Error request client. Please try again later."
    }

    class UnknownCauseHttpException : Exception() {
        override val message: String
            get() = "Something went wrong, verify your internet connection or try again later."
    }

    class UnauthorizedAccessException : BaseHttpException() {
        override val message: String
            get() = "Unauthorized access, please verify your credentials."
    }

    class UnknownCodeHttpException : BaseHttpException() {
        override val message: String
            get() = "Something went wrong, unknown code http error."
    }

    abstract class BaseHttpException : Exception()
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    {
                      "result": {
                        "groups": [
                          {
                            "color": "Brown",
                            "hex": "#A52A2A",
                            "properties": [
                              {
                                "name": "Kamlesh's Humble Abode",
                                "rent": 2
                              },
                              {
                                "name": "Kamlesh's First Business",
                                "rent": 4
                              }
                            ]
                          }
                        ]
                      }
                    }

                    import kotlinx.serialization.Serializable

                    @Serializable
                    data class ResponseBody(
                        val result: ResponseResult
                    ) {
                        @Serializable
                        data class ResponseResult(
                            val groups: List<Group>
                        )
                    }

                    @Serializable
                    data class RequestBody(
                        val data: RequestData
                    ) {
                        @Serializable
                        data class RequestData(
                            val theme: String
                        )

                        companion object {
                            fun create(theme: String) = RequestBody(
                                data = RequestData(
                                    theme = theme
                                )
                            )
                        }
                    }

                    @Serializable
                    data class Property(
                        val name: String,
                        val rent: Int
                    )

                    @Serializable
                    data class Group(
                        val color: String,
                        val hex: String,
                        val properties: List<Property>
                    )

                    class Api {
                        companion object {
                            val instance = Api()
                        }

                        private val client = HttpClient {
                            install(ContentNegotiation) {
                                json(Json {
                                    ignoreUnknownKeys = true
                                    useAlternativeNames = false
                                })
                            }
                        }

                        suspend fun generateProperties(prompt: String): ResponseBody {
                            val response = client.post("https://create-2chqcmsfka-uc.a.run.app/") {
                                contentType(ContentType.Application.Json)
                                setBody(RequestBody.create(
                                    theme = prompt
                                ))
                            }
                            return response.body()
                        }
                    }

                    //CALL API
                    Api.instance.generateProperties(promptValue).result.groups
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Server Image Generate
                    import androidx.compose.foundation.Canvas
                    import androidx.compose.foundation.background
                    import androidx.compose.foundation.layout.Box
                    import androidx.compose.foundation.layout.fillMaxSize
                    import androidx.compose.foundation.layout.padding
                    import androidx.compose.material3.Text
                    import androidx.compose.runtime.Composable
                    import androidx.compose.ui.Modifier
                    import androidx.compose.ui.geometry.Offset
                    import androidx.compose.ui.graphics.Brush
                    import androidx.compose.ui.graphics.Color
                    import androidx.compose.ui.unit.dp
                    import androidx.compose.ui.unit.sp

                    @Composable
                    fun KtorImage(modifier: Modifier = Modifier) {
                        Box(modifier = modifier.background(Color.Black)) {
                            Canvas(modifier = Modifier.fillMaxSize()) {
                                drawCircle(
                                    brush =
                                        Brush.horizontalGradient(
                                            0f to Color.Red,
                                            1f to Color.Blue,
                                        ),
                                    radius = size.minDimension * 0.8f,
                                    center = Offset.Zero,
                                )
                            }

                            Text(
                                modifier = modifier.padding(12.dp),
                                text = "This image was generated using Compose Multiplatform on Ktor server.",
                                fontSize = 20.sp,
                                color = Color.White,
                            )
                        }
                    }

                    import androidx.compose.foundation.layout.fillMaxSize
                    import androidx.compose.ui.ImageComposeScene
                    import androidx.compose.ui.Modifier
                    import androidx.compose.ui.use
                    import io.ktor.http.ContentType
                    import io.ktor.http.HttpStatusCode
                    import io.ktor.server.application.Application
                    import io.ktor.server.application.call
                    import io.ktor.server.engine.embeddedServer
                    import io.ktor.server.netty.Netty
                    import io.ktor.server.response.respondBytes
                    import io.ktor.server.routing.get
                    import io.ktor.server.routing.routing
                    import org.jetbrains.skia.EncodedImageFormat

                    fun main() {
                        embeddedServer(
                            factory = Netty,
                            port = 8080,
                            host = "0.0.0.0",
                            module = Application::module,
                        ).start(wait = true)
                    }

                    fun Application.module() {
                        routing {
                            get("/image") {
                                val width = call.parameters["width"]?.toIntOrNull() ?: 256
                                val height = call.parameters["height"]?.toIntOrNull() ?: 256

                                call.respondBytes(contentType = ContentType.Image.PNG, status = HttpStatusCode.OK) {
                                    val scene =
                                        ImageComposeScene(
                                            width = width,
                                            height = height,
                                        ) {
                                            KtorImage(Modifier.fillMaxSize())
                                        }

                                    val image =
                                        scene.use {
                                            it
                                                .render(nanoTime = 0)
                                                .encodeToData(format = EncodedImageFormat.PNG) ?: error("encoding failed")
                                        }

                                    image.bytes
                                }
                            }
                        }
                    }

                    //http://0.0.0.0:8080/image?width=400&height=200
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //createClientPlugin with Arrow library

                    //iosMain
                    import io.ktor.client.HttpClient
                    import io.ktor.client.HttpClientConfig
                    import io.ktor.client.engine.HttpClientEngineConfig
                    import io.ktor.client.engine.darwin.Darwin

                    actual fun getClient(
                        config:HttpClientConfig<HttpClientEngineConfig>.()-> Unit
                    ):HttpClient{
                        return HttpClient(Darwin, config)
                    }

                    //androidMain
                    import io.ktor.client.HttpClient
                    import io.ktor.client.HttpClientConfig
                    import io.ktor.client.engine.HttpClientEngineConfig
                    import io.ktor.client.engine.okhttp.OkHttp

                    actual fun getClient(
                        config: HttpClientConfig<HttpClientEngineConfig>.() -> Unit
                    ): HttpClient {
                        return HttpClient(OkHttp, config)
                    }

                    import io.ktor.client.HttpClient
                    import io.ktor.client.HttpClientConfig
                    import io.ktor.client.engine.HttpClientEngineConfig
                    import io.ktor.client.plugins.HttpTimeout
                    import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
                    import io.ktor.client.plugins.defaultRequest
                    import io.ktor.client.plugins.logging.LogLevel
                    import io.ktor.client.plugins.logging.Logger
                    import io.ktor.client.plugins.logging.Logging
                    import io.ktor.client.plugins.observer.ResponseObserver
                    import io.ktor.serialization.kotlinx.json.json
                    import kotlinx.serialization.json.Json

                    expect fun getClient(
                        config: HttpClientConfig<HttpClientEngineConfig>.() -> Unit
                    ): HttpClient

                    val httpClient: HttpClient by lazy {
                        getClient(
                            config = {
                                install(RestInterceptors)

                                defaultRequest {
                                    headers["Content-Type"] = "application/json"
                                    host = ""
                                    port = 5035
                                }
                                install(HttpTimeout){
                                    requestTimeoutMillis = 2000
                                    connectTimeoutMillis = 2000
                                    socketTimeoutMillis = 2000
                                }
                                installContentNegotiation()
                                installResponseObserver()
                                installLogging()
                            }
                        )
                    }

                    private fun HttpClientConfig<*>.installContentNegotiation() {
                        install(ContentNegotiation) {
                            json(
                                json = Json {
                                    prettyPrint = true
                                    isLenient = true
                                    ignoreUnknownKeys = true
                                }
                            )
                        }
                    }

                    private fun HttpClientConfig<*>.installLogging() {
                        install(Logging) {
                            logger = object : Logger {
                                override fun log(message: String) {
                                    println(message)
                                }
                            }
                            level = LogLevel.ALL
                        }
                    }

                    private fun HttpClientConfig<*>.installResponseObserver() {
                        install(ResponseObserver) {
                            onResponse {
                                println(it)
                            }
                        }
                    }

                    import io.ktor.client.plugins.api.ClientPlugin
                    import io.ktor.client.plugins.api.createClientPlugin
                    import io.ktor.client.request.HttpRequestBuilder
                    import io.ktor.client.statement.HttpResponse

                    interface RequestResponseInterceptor {
                        suspend fun onRequest(req: HttpRequestBuilder) {}
                        suspend fun onResponse(response: HttpResponse) {}
                        fun onClose(){}
                    }
                    private var interceptors: MutableList<RequestResponseInterceptor> = mutableListOf()

                    object RestInterceptors : ClientPlugin<Unit> by createClientPlugin("TokenPlugin", body = {
                        onRequest { request, _ ->
                           interceptors.forEach {
                               it.onRequest(request)
                           }
                        }
                        onResponse { httpResponse ->
                            interceptors.forEach {
                                it.onResponse(httpResponse)
                            }
                        }
                        onClose {
                            interceptors.forEach {
                                it.onClose()
                            }
                        }
                    })

                    fun RestInterceptors.addInterceptor(
                        requestResponseInterceptor: RequestResponseInterceptor
                    ){
                        interceptors.add(requestResponseInterceptor)
                    }
                    fun RestInterceptors.removeInterceptor(
                        requestResponseInterceptor: RequestResponseInterceptor
                    ){
                        interceptors.remove(requestResponseInterceptor)
                    }


                    import arrow.core.None
                    import arrow.core.Some
                    import com.shared.auth.viewmodel.usecases.UseCaseGetAuthToken
                    import com.shared.compose_foundation.koin.ModuleInitilizer
                    import com.shared.compose_foundation.ktor.RequestResponseInterceptor
                    import com.shared.compose_foundation.ktor.RestInterceptors
                    import com.shared.compose_foundation.ktor.addInterceptor
                    import io.ktor.client.request.HttpRequestBuilder
                    import io.ktor.client.request.header
                    import io.ktor.http.HttpHeaders
                    import org.koin.core.KoinApplication
                    import org.koin.core.component.get

                    /**
                     * Singleton object responsible for initializing Koin modules related to authentication
                     * and handling HTTP request interception for authorization tokens.
                     *
                     * Implements [ModuleInitializer] to configure Koin modules and [RequestResponseInterceptor]
                     * to modify HTTP requests with authorization tokens.
                     *
                     * This object should be used to set up authentication-related dependencies and ensure
                     * that HTTP requests include the necessary authorization headers.
                     *
                     * Example usage:
                     * ```
                     * FeatureAuthInitializer.configKoinModules(koinApplication)
                     * ```
                     */
                    object FeatureAuthInitializer : ModuleInitilizer, RequestResponseInterceptor {

                        /**
                         * Lazy-initialized use case for retrieving authentication tokens.
                         *
                         * This property is initialized when accessed and provides an instance of [UseCaseGetAuthToken].
                         */
                        private val useCaseGetAuthToken: UseCaseGetAuthToken by lazy { get() }

                        /**
                         * Configures Koin modules related to authentication.
                         *
                         * @param koinApplication The [KoinApplication] instance used to define and configure Koin modules.
                         *
                         * This method sets up the necessary Koin modules for authentication, including providers
                         * for use cases, API services, and account management.
                         */
                        override fun configKoinModules(koinApplication: KoinApplication) {
                            koinApplication.modules(
                                UseCaseProvider,
                                AuthApiProvider,
                                AccountManagerProvider
                            )
                        }

                        /**
                         * Called after Koin configuration is finished.
                         *
                         * This method adds the current object as an interceptor for handling authorization tokens
                         * in HTTP requests by calling [RestInterceptors.addInterceptor].
                         */
                        override fun onKoinConfigurationFinish() {
                            super.onKoinConfigurationFinish()
                            RestInterceptors.addInterceptor(this)
                        }

                        /**
                         * Intercepts HTTP requests to add an authorization token header.
                         *
                         * @param req The [HttpRequestBuilder] representing the HTTP request to be modified.
                         *
                         * This method retrieves the current authentication token using [useCaseGetAuthToken]
                         * and, if available, adds it to the request headers as a Bearer token.
                         */
                        override suspend fun onRequest(req: HttpRequestBuilder) {
                            when (val it = useCaseGetAuthToken.getToken().value) {
                                None -> {}
                                is Some -> { req.header(HttpHeaders.Authorization, it.value}) }
                            }
                        }
                    }

                    import arrow.core.Option
                    import kotlinx.coroutines.flow.StateFlow

                    interface UseCaseGetAuthToken {
                        fun getToken(): StateFlow<Option<String>>
                    }

                    import arrow.core.Option
                    import kotlinx.coroutines.flow.StateFlow

                    internal class UseCaseGetAuthTokenDefaultImpl(
                        val authManger: AuthManager
                    ):UseCaseGetAuthToken {
                        override fun getToken(): StateFlow<Option<String>> {
                            return authManger.token
                        }
                    }

                    import org.koin.core.KoinApplication
                    import org.koin.core.component.KoinComponent

                    /**
                     * Interface for initializing Koin modules in an application.
                     *
                     * Implement this interface to configure Koin modules and perform additional actions
                     * after Koin has been configured. This allows for custom setup logic during the
                     * initialization phase of Koin in your application.
                     *
                     * Example usage:
                     * ```
                     * class MyModuleInitializer : ModuleInitializer {
                     *     override fun configKoinModules(koinApplication: KoinApplication) {
                     *         // Define and configure Koin modules here
                     *         koinApplication.modules(myModule)
                     *     }
                     *
                     *     override fun onKoinConfigurationFinish() {
                     *         // Perform actions after Koin configuration is complete
                     *     }
                     * }
                     * ```
                     */
                    interface ModuleInitilizer: KoinComponent {
                        /**
                         * Configures Koin modules.
                         *
                         * @param koinApplication The KoinApplication instance used to define and configure modules.
                         *
                         * Implement this method to specify which Koin modules should be loaded into the application.
                         */
                        fun configKoinModules(koinApplication: KoinApplication)

                        /**
                         * Called after Koin configuration is finished.
                         *
                         * Override this method to perform any additional setup or initialization tasks
                         * that need to occur after Koin modules have been configured.
                         *
                         * This method has a default implementation that does nothing, so it is optional
                         * to override it in your implementation.
                         */
                        fun onKoinConfigurationFinish(){}
                    }

                    fun KoinApplication.configCommonModules() {
                        setUpDI()
                    }

                    private fun KoinApplication.setUpDI() {
                        listOf(

                        ).onEach {
                            it.configKoinModules(this)
                        }.onEach {
                            it.onKoinConfigurationFinish()
                        }
                    }

                    @Serializable
                    data class Issue(
                        @SerialName("message")
                        val message: String,
                        @SerialName("key")
                        val key: String
                    )

                    open class HttpException(
                        val response: HttpResponse,
                        message: String,
                    ) : Exception(message)

                    class ClientSideError(
                        response: HttpResponse,
                        val issue: Issue
                    ) : HttpException(response, "Client side error")

                    class ServerSideError(
                        response: HttpResponse
                    ) : HttpException(response, "Server side error")

                    suspend fun HttpResponse.ensureSuccessfulRequest(): HttpResponse = apply {
                        when (status.value) {
                            in 200..299 -> return@apply
                            in 400..499 -> throw ClientSideError(this, body())
                            in 500..599 -> throw ServerSideError(this)
                            else -> throw HttpException(this, "Unknown error")
                        }
                    }

                    import com.shared.compose_foundation.ktor.ClientSideError
                    import com.shared.compose_foundation.ktor.ServerSideError
                    import io.ktor.utils.io.errors.IOException

                    class RequestFailure(
                        val exception: Throwable
                    ) {
                        inline fun isClientSideError(action: (ClientSideError) -> Unit) = apply {
                            if (this.exception is ClientSideError)
                                action(exception)
                        }

                        inline fun isServerSideError(action: (ServerSideError) -> Unit) = apply {
                            if (this.exception is ServerSideError)
                                action(exception)
                        }

                        inline fun isIOEException(action: (IOException) -> Unit) = apply {
                            if (exception is IOException)
                                exception.apply(action)
                        }

                        inline fun isUnKnownError(action: Throwable.() -> Unit) = apply {
                            if (
                                exception !is ServerSideError
                                && exception !is ClientSideError
                                && exception !is IOException
                            ) {
                                exception.apply(action)
                            }
                        }
                    }

                    import arrow.core.Either
                    import arrow.core.raise.either

                    inline fun <T> apiCallScope(action:  () -> T): Either<RequestFailure, T> {
                        return either {
                            try {
                                action()
                            } catch (e: Exception) {
                                raise(RequestFailure(e))
                            }
                        }
                    }

                    //https://github.com/AbhijithMogaveera/TicTacToe-ComposeMultiplatform
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    import core.network.ktorHelpers.KtorLogger
                    import core.network.ktorHelpers.addTokenInterceptor
                    import core.network.utils.Rout.TIME_OUT
                    import core.sharedPlatform.NetworkConfig
                    import io.github.aakira.napier.DebugAntilog
                    import io.github.aakira.napier.Napier
                    import io.ktor.client.HttpClient
                    import io.ktor.client.plugins.DefaultRequest
                    import io.ktor.client.plugins.HttpTimeout
                    import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
                    import io.ktor.client.plugins.cookies.AcceptAllCookiesStorage
                    import io.ktor.client.plugins.cookies.HttpCookies
                    import io.ktor.client.plugins.logging.LogLevel
                    import io.ktor.client.plugins.logging.Logging
                    import io.ktor.client.request.header
                    import io.ktor.http.ContentType
                    import io.ktor.http.HttpHeaders
                    import io.ktor.serialization.kotlinx.json.json
                    import kotlinx.serialization.ExperimentalSerializationApi
                    import kotlinx.serialization.json.Json
                    import org.koin.dsl.module

                    @OptIn(ExperimentalSerializationApi::class)
                    val networkModule = module {
                        single {
                            val userManagerRepository: UserManagerRepository by inject<UserManagerRepository>()

                            HttpClient() {
                                install(Logging) {
                                    logger = KtorLogger()
                                    level = LogLevel.ALL
                                }
                                install(DefaultRequest) {
                                    url(NetworkConfig.baseUrl)
                                    header(HttpHeaders.ContentType, ContentType.Application.Json)

                                }
                                install(HttpCookies) {
                                    storage = AcceptAllCookiesStorage()
                                }
                                install(ContentNegotiation) {
                                    json(Json {
                                        encodeDefaults = false
                                        explicitNulls = false
                                        ignoreUnknownKeys = true
                                    })
                                }
                                install(HttpTimeout) {
                                    requestTimeoutMillis = TIME_OUT
                                    connectTimeoutMillis = TIME_OUT
                                    socketTimeoutMillis = TIME_OUT
                                }
                                addTokenInterceptor { userManagerRepository.getUserToken() }
                            }.also { Napier.base(DebugAntilog()) }
                        }
                    }

                    import io.ktor.client.HttpClient
                    import io.ktor.client.HttpClientConfig
                    import io.ktor.client.call.body
                    import io.ktor.client.plugins.DefaultRequest
                    import io.ktor.client.request.get
                    import io.ktor.client.request.headers
                    import io.ktor.client.request.post
                    import io.ktor.client.request.setBody
                    import io.ktor.client.statement.HttpResponse
                    import io.ktor.http.isSuccess
                    import io.ktor.http.path
                    import kotlinx.coroutines.runBlocking

                    // Generic function for making requests
                    suspend inline fun <reified T> HttpClient.getRequest(
                        path: String,
                        queryParams: Map<String, String> = emptyMap(),
                    ): ApiResponse<T> {
                        return try {
                            val response: HttpResponse = this.get {
                                url {
                                    path(path)
                                    queryParams.forEach { (key, value) ->
                                        parameters.append(key, value)
                                    }
                                }
                            }

                            if (response.status.isSuccess()) {
                                val responseBody: T = response.body()
                                ApiResponse.Success(responseBody)
                            } else {
                                val errorResponse: ErrorResponseModel = response.body()
                                ApiResponse.Error(errorResponse.message)
                            }
                        } catch (e: Exception) {
                            ApiResponse.Error(e.message ?: "An unknown error occurred")
                        }
                    }

                    suspend inline fun <reified T> HttpClient.postRequest(
                        path: String,
                        requestBody: Any? = null,
                        queryParams: Map<String, String> = emptyMap(),
                    ): ApiResponse<T> {
                        return try {
                            val response: HttpResponse = this.post {
                                url {
                                    path(path)
                                    queryParams.forEach { (key, value) ->
                                        parameters.append(key, value)
                                    }
                                }
                                setBody(requestBody)
                            }

                            if (response.status.isSuccess()) {
                                val responseBody: T = response.body()
                                ApiResponse.Success(responseBody)
                            } else {
                                val errorResponse: ErrorResponseModel = response.body()
                                ApiResponse.Error(errorResponse.message)
                            }
                        } catch (e: Exception) {
                            ApiResponse.Error(e.message ?: "An unknown error occurred")
                        }
                    }

                    // interceptors
                    fun HttpClientConfig<*>.addTokenInterceptor(tokenProvider: suspend () -> String) {
                        install(DefaultRequest) {
                            headers {
                                val token = runBlocking { tokenProvider() }
                                if (token.isNotEmpty()) {
                                    append("Authorization", "Bearer Token Here")
                                }
                            }
                        }
                    }

                    import kotlinx.serialization.Serializable

                    @Serializable
                    sealed class ApiResponse<out T> {
                        @Serializable
                        data class Success<out T>(val data: T) : ApiResponse<T>()

                        @Serializable
                        data class Error(val message: String) : ApiResponse<Nothing>()
                    }

                    @Serializable
                    data class ErrorResponseModel(
                        val status: String,
                        val message: String,
                        val success: Boolean,
                    )
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    private const val BASE_URL = "api.untappd.com"
                    private const val V4 = "v4"
                    private const val SEARCH = "search"
                    private const val BEER = "beer"
                    private const val Brewery = "brewery"
                    private const val INFO = "info"

                    class UntappdService @OptIn(ExperimentalOpenIdConnect::class) constructor(
                        private val ktorClient: HttpClient,
                        private val tokenStore: TokenStore
                    ) {
                        @OptIn(ExperimentalOpenIdConnect::class)
                        suspend fun searchBeer(searchName: String, offset: Int? = null): Result<SearchBeerResponse> {
                            val token = tokenStore.getAccessToken()!!
                            return ktorClient.fetch {
                                url {
                                    protocol = URLProtocol.HTTPS
                                    host = BASE_URL
                                    method = HttpMethod.Get
                                    appendPathSegments(V4, SEARCH, BEER)
                                    with(parameters) {
                                        append("q", searchName)
                                        offset?.let { append("offset", it.toString()) }
                                        append("access_token", token)
                                    }
                                }
                            }
                        }
                    }

                    class SearchRepositoryImpl(
                        private val service: UntappdService
                    ) : SearchRepository, KoinComponent {
                        override suspend fun search(searchName: String): Result<BeersWithPagination> {
                            return service.searchBeer(searchName)
                                .mapCatching { it.toBeersWithPagination() }
                        }
                    }

                    import io.ktor.client.HttpClient
                    import io.ktor.client.call.body
                    import io.ktor.client.request.HttpRequestBuilder
                    import io.ktor.client.request.request
                    import io.ktor.client.statement.bodyAsText
                    import io.ktor.http.HttpStatusCode
                    import kotlinx.coroutines.Dispatchers
                    import kotlinx.coroutines.IO
                    import kotlinx.coroutines.withContext

                    suspend inline fun <reified T> HttpClient.fetch(
                        crossinline block: HttpRequestBuilder.() -> Unit
                    ): Result<T> = withContext(Dispatchers.IO) {
                        try {
                            val response = request(block)

                            if (response.status == HttpStatusCode.OK) {
                                Result.success(response.body())
                            } else {
                                Result.failure(Throwable(response.bodyAsText()))
                            }
                        } catch (e: Exception) {
                            Result.failure(e)
                        }
                    }
                """.trimIndent()
            )

            KotlinCode(
                code = """
                    import io.ktor.client.*
                    import io.ktor.client.request.*
                    import io.ktor.client.statement.*
                    import io.ktor.http.*
                    import io.ktor.client.call.*
                    import io.ktor.client.plugins.contentnegotiation.*
                    import io.ktor.client.engine.cio.*
                    import io.ktor.serialization.kotlinx.json.*
                    import kotlinx.coroutines.*
                    import java.io.File

                    suspend fun uploadImage(imageFile: File): HttpResponse {
                        val client = HttpClient(CIO) {
                            install(ContentNegotiation) {
                                json()
                            }
                        }

                        return client.use {
                            it.submitFormWithBinaryData(
                                url = "",
                                formData = formData {
                                    append(
                                        "image",
                                        imageFile.readBytes(),
                                        Headers.build {
                                            append(HttpHeaders.ContentType, ContentType.Image.Any)
                                            append(HttpHeaders.ContentDisposition, "filename=")
                                        }
                                    )
                                }
                            )
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    sealed interface Result<out D, out E: Error> {
                        data class Success<out D>(val data: D): Result<D, Nothing>
                        data class Error<out E: util.Error>(val error: E): Result<Nothing, E>
                    }

                    inline fun <T, E: Error, R> Result<T, E>.map(map: (T) -> R): Result<R, E> {
                        return when(this) {
                            is Result.Error -> Result.Error(error)
                            is Result.Success -> Result.Success(map(data))
                        }
                    }

                    fun <T, E: Error> Result<T, E>.asEmptyDataResult(): EmptyResult<E> {
                        return map {  }
                    }

                    inline fun <T, E: Error> Result<T, E>.onSuccess(action: (T) -> Unit): Result<T, E> {
                        return when(this) {
                            is Result.Error -> this
                            is Result.Success -> {
                                action(data)
                                this
                            }
                        }
                    }
                    inline fun <T, E: Error> Result<T, E>.onError(action: (E) -> Unit): Result<T, E> {
                        return when(this) {
                            is Result.Error -> {
                                action(error)
                                this
                            }
                            is Result.Success -> this
                        }
                    }

                    typealias EmptyResult<E> = Result<Unit, E>

                    enum class NetworkError : Error {
                        REQUEST_TIMEOUT,
                        UNAUTHORIZED,
                        CONFLICT,
                        TOO_MANY_REQUESTS,
                        NO_INTERNET,
                        PAYLOAD_TOO_LARGE,
                        SERVER_ERROR,
                        SERIALIZATION,
                        UNKNOWN,
                        NOTING_TO_SYNC;
                    }

                    interface Error

                    interface StrapiSyncApi<T, R> {
                        suspend fun fetchItemsAfterTimestamp(timestamp: Long, userID: String): Result<List<T>, NetworkError>
                    }

                    class StrapiCountdownTimerApiClient(
                        private val serverHost: String
                    ): StrapiSyncApi<CountdownTimer, SyncResponse> {

                        private val httpClient: HttpClient = createHttpClient()

                        enum class ApiEndpoint(var urlPath: String, val method: HttpMethod) {
                            COUNTDOWN_TIMER_FETCH_TIMERS_AFTER_TIMESTAMP("/api/timer/fetchItemsAfterTimeStamp?timeStamp={timestamp}&userId={userID}", HttpMethod.Get)
                        }

                        override suspend fun fetchItemsAfterTimestamp(timestamp: Long, userID: String): Result<List<CountdownTimer>, NetworkError> {
                            val endpoint = ApiEndpoint.COUNTDOWN_TIMER_FETCH_TIMERS_AFTER_TIMESTAMP
                            endpoint.urlPath = endpoint.urlPath.replace("{timestamp}", timestamp.toString()).replace("{userID}", userID)
                            return apiCall(endpoint, timestamp)
                        }

                        private suspend inline fun <reified T> apiCall(endpoint: ApiEndpoint, body: Any? = null): Result<T, NetworkError> {
                            val response = try {
                                when (endpoint.method) {
                                    HttpMethod.Get -> httpClient.get {
                                        url("")
                                    }
                                    HttpMethod.Post -> httpClient.post {
                                        url("")
                                        contentType(ContentType.Application.Json)
                                        setBody(body)
                                    }
                                    HttpMethod.Put -> httpClient.put {
                                        url("")
                                        contentType(ContentType.Application.Json)
                                        setBody(body)
                                    }
                                    HttpMethod.Delete -> httpClient.delete {
                                        url("")
                                    }
                                    else -> throw UnsupportedOperationException("Unsupported HTTP method")
                                }
                            } catch (e: UnresolvedAddressException) {
                                return Result.Error(NetworkError.NO_INTERNET)
                            } catch (e: SerializationException) {
                                return Result.Error(NetworkError.SERIALIZATION)
                            } catch (e: Exception) {
                                return Result.Error(NetworkError.REQUEST_TIMEOUT)
                            }

                            return handleResult<T>(response)
                        }

                        private suspend inline fun <reified T> handleResult(response: HttpResponse): Result<T, NetworkError> {
                            return when (response.status.value) {
                                in 200..299 -> {
                                    try {
                                        Result.Success(response.body())
                                    } catch (e: SerializationException) {
                                        Result.Error(NetworkError.SERIALIZATION)
                                    }
                                }
                                401 -> Result.Error(NetworkError.UNAUTHORIZED)
                                409 -> Result.Error(NetworkError.CONFLICT)
                                430 -> Result.Error(NetworkError.NOTING_TO_SYNC)
                                408 -> Result.Error(NetworkError.REQUEST_TIMEOUT)
                                413 -> Result.Error(NetworkError.PAYLOAD_TOO_LARGE)
                                in 500..599 -> Result.Error(NetworkError.SERVER_ERROR)
                                else -> Result.Error(NetworkError.UNKNOWN)
                            }
                        }
                    }

                    //ViewModel
                    val response = apiService.fetchItemsAfterTimestamp( , )
                    response.onSuccess { serverTimers ->

                    }
                    response.onError { return }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //https://github.com/vishal2376/bookie

                    suspend inline fun <reified T> safeCall(
                    	execute: () -> HttpResponse
                    ): Result<T, DataError.Remote> {
                    	val response = try {
                    		execute()
                    	} catch (e: SocketTimeoutException) {
                    		return Result.Error(DataError.Remote.REQUEST_TIMEOUT)
                    	} catch (e: UnresolvedAddressException) {
                    		return Result.Error(DataError.Remote.NO_INTERNET)
                    	} catch (e: Exception) {
                    		coroutineContext.ensureActive()
                    		return Result.Error(DataError.Remote.UNKNOWN)
                    	}
                    	return responseToResult(response = response)
                    }

                    suspend inline fun <reified T> responseToResult(
                    	response: HttpResponse
                    ): Result<T, DataError.Remote> {
                    	return when (response.status.value) {
                    		in 200..299 -> {
                    			try {
                    				Result.Success(response.body<T>())
                    			} catch (e: NoTransformationFoundException) {
                    				Result.Error(DataError.Remote.SERIALIZATION)
                    			}
                    		}

                    		408 -> Result.Error(DataError.Remote.REQUEST_TIMEOUT)
                    		429 -> Result.Error(DataError.Remote.TOO_MANY_REQUESTS)
                    		in 500..599 -> Result.Error(DataError.Remote.SERVER)
                    		else -> Result.Error(DataError.Remote.UNKNOWN)
                    	}
                    }

                    object HttpClientFactory {
                    	fun create(engine: HttpClientEngine): HttpClient {
                    		return HttpClient(engine) {
                    			install(ContentNegotiation) {
                    				json(Json {
                    					ignoreUnknownKeys = true
                    				})
                    			}

                    			install(HttpTimeout) {
                    				socketTimeoutMillis = 20_000
                    				requestTimeoutMillis = 20_000
                    			}

                    			install(Logging) {
                    				logger = object : Logger {
                    					override fun log(message: String) {
                    						println(message)
                    					}

                    				}
                    				level = LogLevel.ALL
                    			}

                    			defaultRequest {
                    				contentType(ContentType.Application.Json)
                    			}
                    		}
                    	}
                    }

                    //domain
                    sealed interface DataError : Error {
                    	enum class Remote : DataError {
                    		REQUEST_TIMEOUT,
                    		TOO_MANY_REQUESTS,
                    		NO_INTERNET,
                    		SERVER,
                    		SERIALIZATION,
                    		UNKNOWN
                    	}

                    	enum class Local : DataError {
                    		NO_DATA,
                    		DISK_FULL,
                    		UNKNOWN
                    	}
                    }

                    interface Error

                    sealed interface Result<out D, out E: Error> {
                        data class Success<out D>(val data: D): Result<D, Nothing>
                        data class Error<out E: com.vishal2376.bookie.core.domain.Error>(val error: E):
                            Result<Nothing, E>
                    }

                    inline fun <T, E: Error, R> Result<T, E>.map(map: (T) -> R): Result<R, E> {
                        return when(this) {
                            is Result.Error -> Result.Error(error)
                            is Result.Success -> Result.Success(map(data))
                        }
                    }

                    fun <T, E: Error> Result<T, E>.asEmptyDataResult(): EmptyResult<E> {
                        return map {  }
                    }

                    inline fun <T, E: Error> Result<T, E>.onSuccess(action: (T) -> Unit): Result<T, E> {
                        return when(this) {
                            is Result.Error -> this
                            is Result.Success -> {
                                action(data)
                                this
                            }
                        }
                    }
                    inline fun <T, E: Error> Result<T, E>.onError(action: (E) -> Unit): Result<T, E> {
                        return when(this) {
                            is Result.Error -> {
                                action(error)
                                this
                            }
                            is Result.Success -> this
                        }
                    }

                    typealias EmptyResult<E> = Result<Unit, E>
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //https://github.com/Suwayomi/Suwayomi-JUI

                    @OptIn(DelicateCoroutinesApi::class)
                    abstract class WebsocketService(
                        protected val serverPreferences: ServerPreferences,
                        protected val client: Http,
                    ) {
                        protected val json = Json {
                            ignoreUnknownKeys = true
                        }
                        protected abstract val _status: MutableStateFlow<Status>

                        private val serverUrl = serverPreferences.serverUrl().stateIn(GlobalScope)

                        private var errorConnectionCount = 0

                        private var job: Job? = null

                        fun init() {
                            errorConnectionCount = 0
                            job?.cancel()
                            job = serverUrl
                                .mapLatest { serverUrl ->
                                    _status.value = Status.STARTING
                                    while (true) {
                                        if (errorConnectionCount > 3) {
                                            _status.value = Status.STOPPED
                                            throw CancellationException("Finish")
                                        }
                                        runCatching {
                                            client.ws(
                                                host = serverUrl.host,
                                                port = serverUrl.port,
                                                path = serverUrl.encodedPath + query,
                                                request = {
                                                    if (serverUrl.protocol == URLProtocol.HTTPS) {
                                                        url.protocol = URLProtocol.WSS
                                                    }
                                                },
                                            ) {
                                                errorConnectionCount = 0
                                                _status.value = Status.RUNNING
                                                send(Frame.Text("STATUS"))

                                                incoming.receiveAsFlow()
                                                    .filterIsInstance<Frame.Text>()
                                                    .mapLatest(::onReceived)
                                                    .catch {
                                                        log.warn(it) { "Error running websocket" }
                                                    }
                                                    .collect()
                                            }
                                        }.throwIfCancellation().isFailure.let {
                                            _status.value = Status.STARTING
                                            if (it) errorConnectionCount++
                                        }
                                    }
                                }
                                .catch {
                                    _status.value = Status.STOPPED
                                    log.warn(it) { "Error while running websocket service" }
                                }
                                .launchIn(GlobalScope)
                        }

                        abstract val query: String

                        abstract suspend fun onReceived(frame: Frame.Text)

                        enum class Status {
                            STARTING,
                            RUNNING,
                            STOPPED,
                        }

                        enum class Actions {
                            STOP,
                            START,
                            RESTART,
                        }

                        private companion object {
                            val log = logging()
                        }
                    }

                    class DownloadService
                        @Inject
                        constructor(
                            serverPreferences: ServerPreferences,
                            client: Http,
                        ) : WebsocketService(serverPreferences, client) {
                            override val _status: MutableStateFlow<Status>
                                get() = status

                            override val query: String
                                get() = "/api/v1/downloads"

                            override suspend fun onReceived(frame: Frame.Text) {
                                val status = json.decodeFromString<DownloadStatus>(frame.readText())
                                downloaderStatus.value = status.status
                                downloadQueue.value = status.queue
                            }

                            companion object {
                                val status = MutableStateFlow(Status.STARTING)
                                val downloadQueue = MutableStateFlow(emptyList<DownloadChapter>())
                                val downloaderStatus = MutableStateFlow(DownloaderStatus.Stopped)

                                fun registerWatch(mangaId: Long) =
                                    downloadQueue
                                        .map {
                                            it.filter { it.mangaId == mangaId }
                                        }

                                fun registerWatches(mangaIds: Set<Long>) =
                                    downloadQueue
                                        .map {
                                            it.filter { it.mangaId in mangaIds }
                                        }
                            }
                        }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //https://github.com/Abdelrahman-SW/TicTacToe_Compose_MultiPlatform_Game

                    val sharedModule = module {
                        single {
                            HttpClient(CIO) {
                                install(WebSockets)
                            }
                        }
                    }

                    interface RealtimeTicTacToeMessagingClient {
                        suspend fun getSessionIsActiveState(): Flow<Boolean>
                        suspend fun connectToWebSocket(username: String) : Boolean
                        fun getGameStateStream(): Flow<GameState>
                        suspend fun sendPlayerTurn(action: PlayerTurn)
                        suspend fun disconnect()

                        companion object {
                            // 172.23.64.1 : is my device ip address replace it with your own ip
                            const val BASE_URL = "ws://0.0.0.0:8080/"
                            const val TicTacToe_SOCKET_ENDPOINT = "play"
                        }
                    }

                    class RealtimeTicTacToeMessagingClientKtorImpl(
                        private val client: HttpClient
                    ) : RealtimeTicTacToeMessagingClient {
                        private var socketSession: WebSocketSession? = null
                        override suspend fun getSessionIsActiveState(): Flow<Boolean> = flow {
                            while (socketSession!=null) {
                                val isSessionActive = socketSession?.isActive == true
                                emit(isSessionActive)
                                delay(1000) // Check every second, adjust this as needed
                            }
                        }

                        override suspend fun connectToWebSocket(username: String): Boolean {
                            return try {
                                socketSession = client.webSocketSession {
                                    url("")
                                }
                                socketSession?.isActive == true
                            } catch (e: Exception) {
                                return false
                            }
                        }

                        override fun getGameStateStream(): Flow<GameState> {
                            return try {
                                socketSession?.let { socketSession ->
                                    socketSession.incoming
                                        .receiveAsFlow()
                                        .filterIsInstance<Frame.Text>()
                                        .map { Json.decodeFromString<GameStateDto>(it.readText()).toGameState() }
                                } ?: flow { }
                            } catch (e: Exception) {
                                e.printStackTrace()
                                flow { emit(GameState()) }
                            }
                        }

                        override suspend fun sendPlayerTurn(action: PlayerTurn) {
                            try {
                                socketSession?.send(Frame.Text(Json.encodeToString(action)))
                            } catch (e: Exception) {
                                e.printStackTrace()
                            }
                        }

                        override suspend fun disconnect() {
                            println("Disconnecting")
                            socketSession?.close()
                            socketSession = null
                            println("Disconnected")

                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //https://github.com/djkovrik/Tackle (Multiple Image Upload ProgressBar)

                    internal abstract class BaseApi(
                        private val domainProvider: () -> String,
                        private val tokenProvider: () -> String,
                    ) {
                        protected val appToken: String
                            get() = tokenProvider.invoke()

                        protected val instanceUrl: String
                            get() = domainProvider.invoke()

                        private val json: Json = Json {
                            coerceInputValues = true
                            ignoreUnknownKeys = true
                            useAlternativeNames = false
                        }

                        private val httpClient: HttpClient = HttpClient {
                            install(ContentNegotiation) { json(json) }
                        }

                        @Throws(Exception::class)
                        @Suppress("ThrowsCount", "SwallowedException")
                        protected suspend inline fun <reified From, To> BaseApi.doRequest(
                            requestUrl: String,
                            requestMethod: HttpMethod,
                            authenticated: Boolean,
                            responseMapper: (From) -> To,
                            additionalConfig: HttpRequestBuilder.() -> Unit = {},
                        ): To {
                            try {

                                val response: HttpResponse = httpClient.request(requestUrl) {

                                    method = requestMethod

                                    headers {
                                        append(HttpHeaders.Accept, "*/*")
                                        append(HttpHeaders.UserAgent, Constants.USER_AGENT)

                                        if (authenticated) {
                                            append(HttpHeaders.Authorization, "")
                                        }
                                    }

                                    additionalConfig.invoke(this)
                                }

                                if (!response.status.isSuccess()) {
                                    val errorDetails: RemoteErrorResponse? = response.remoteErrorDetails()
                                    throw TackleException.RemoteServerException(
                                        description = errorDetails?.errorDescription,
                                        code = response.status.value,
                                        message = errorDetails?.error,
                                    )
                                }

                                return responseMapper(json.decodeFromString<From>(response.body()))
                            } catch (exception: SerializationException) {
                                throw TackleException.SerializationException(exception)
                            } catch (exception: IOException) {
                                throw TackleException.NetworkException(exception)
                            } catch (exception: ClientRequestException) {
                                throw TackleException.Unknown(exception)
                            }
                        }

                        @Suppress("SwallowedException")
                        suspend inline fun HttpResponse.remoteErrorDetails(): RemoteErrorResponse? =
                            try {
                                json.decodeFromString<RemoteErrorResponse>(body())
                            } catch (e: SerializationException) {
                                null
                            }

                        internal object Constants {
                            const val USER_AGENT = "Tackle"
                            const val BEARER = "Bearer"
                            const val GRANT_TYPE = "authorization_code"
                        }
                    }

                    @Serializable
                    internal class RemoteErrorResponse(
                        @SerialName("error") val error: String = "",
                        @SerialName("error_description ") val errorDescription: String = "",
                    )

                    sealed class TackleException(
                        override val message: String? = null,
                        override val cause: Throwable? = null,
                        val action: Action = Action.NONE,
                    ) : Exception(message, cause) {

                        data object MissedRegistrationData : TackleException()

                        class NetworkException(
                            cause: Throwable,
                        ) : TackleException(
                            cause = cause,
                            action = Action.SHOW_MESSAGE,
                        )

                        class RemoteServerException(
                            val description: String?,
                            val code: Int?,
                            message: String?,
                        ) : TackleException(
                            message = message,
                            action = if (code == HTTP_CODE_UNAUTHORIZED) {
                                Action.LOGOUT
                            } else {
                                Action.SHOW_MESSAGE
                            },
                        )

                        class SerializationException(
                            cause: Throwable,
                        ) : TackleException(
                            cause = cause,
                            action = Action.SHOW_MESSAGE,
                        )

                        data object FileSizeExceeded : TackleException(action = Action.SHOW_MESSAGE)

                        data object FileTypeNotSupported : TackleException(action = Action.SHOW_MESSAGE)

                        data object FileNotAvailable : TackleException(action = Action.SHOW_MESSAGE)

                        class AttachmentsLimitExceeded(val limit: Int) : TackleException(action = Action.SHOW_MESSAGE)

                        data object ScheduleDateTooShort : TackleException(action = Action.SHOW_MESSAGE)

                        class Unknown(
                            cause: Throwable,
                        ) : TackleException(
                            cause = cause,
                            action = Action.SHOW_MESSAGE,
                        )

                        enum class Action {
                            SHOW_MESSAGE,
                            LOGOUT,
                            NONE;
                        }

                        private companion object {
                            const val HTTP_CODE_UNAUTHORIZED = 401
                        }
                    }

                    internal class TackleAuthorizedApi(
                        domainProvider: () -> String,
                        tokenProvider: () -> String,
                    ) : BaseApi(domainProvider = domainProvider, tokenProvider = tokenProvider), AuthorizedApi {
                        override suspend fun search(bundle: SearchRequestBundle): Search =
                            doRequest<SearchResponse, Search>(
                                requestUrl = "",
                                requestMethod = HttpMethod.Get,
                                authenticated = true,
                                responseMapper = SearchMapper::map,
                            ) {
                                url {
                                    with(parameters) {
                                        append("q", bundle.query)
                                        append("type", bundle.type)
                                    }
                                }
                            }

                    interface AuthorizedApi {
                        suspend fun search(bundle: SearchRequestBundle): Search
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "WASM Socket (Client - Server Side)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/Cube82/Tasker
            KotlinCode(
                code = $$"""
                    //WASM

                    private const val WS_URL = "ws://127.0.0.1:8082/tasks"
                    internal class TasksViewModel : ViewModel(), WebsocketEvents {
                        private val client = KtorWebsocketClient(WS_URL, this)
                    }

                    interface WebsocketEvents {
                        fun <T> onReceive(data: T)
                        fun onConnected()
                        fun onDisconnected(reason: String)
                        fun log(message: String)
                    }

                    private const val RECONNECT_DELAY = 10_000L

                    class KtorWebsocketClient(
                        private val url: String,
                        private val listener: WebsocketEvents,
                    ) {
                        private val client = HttpClient(Js) {
                            install(Logging)
                            install(WebSockets) {
                                contentConverter = KotlinxWebsocketSerializationConverter(Json {
                                    prettyPrint = true
                                    isLenient = true
                                    ignoreUnknownKeys = true
                                })
                            }
                        }

                        private val scope =
                            CoroutineScope(Dispatchers.Default) + SupervisorJob() + CoroutineExceptionHandler { _, throwable ->
                                log("Error: ${throwable.message}")
                            }

                        private var job: Job? = null

                        private var session: DefaultClientWebSocketSession? = null

                        suspend fun connect() {
                            try {
                                log("Connecting to websocket at $url...")

                                session = client.webSocketSession(url)

                                listener.onConnected()

                                log("Connected to websocket at $url")

                                session!!.incoming
                                    .receiveAsFlow()
                                    .filterNotNull()
                                    .collect { data ->
                                        when (data) {
                                            is Frame.Text -> {
                                                val message = data.readText()
                                                val task: Task = Json.decodeFromString(message)
                                                listener.onReceive(task)

                                                log("Received message: $message")
                                            }

                                            is Frame.Binary -> {
                                                log("Received binary message")
                                            }

                                            is Frame.Close -> {
                                                listener.onDisconnected("Received close message")
                                                log("Received close message")
                                            }

                                            is Frame.Ping -> {
                                                log("Received ping message")
                                            }

                                            is Frame.Pong -> {
                                                log("Received pong message")
                                            }

                                            else -> {
                                                log("Received unknown message")
                                            }
                                        }

                                    }
                            } catch (e: Exception) {
                                listener.onDisconnected(e.message ?: "Unknown error")

                                log("Error: ${e.message}")

                                reconnect()
                            }
                        }

                        private fun reconnect() {
                            job?.cancel()

                            log("Reconnecting to websocket in $RECONNECT_DELAY ms...")

                            job = scope.launch {
                                stop()
                                delay(RECONNECT_DELAY)
                                connect()
                            }
                        }

                        suspend fun stop() {
                            log("Closing websocket session...")

                            session?.close()
                            session = null
                        }

                        internal suspend inline fun <reified T> send(message: T) {
                            log("Sending message: $message")
                            session?.sendSerialized(message)
                        }

                        fun log(message: String) {
                            listener.log(message)
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = $$"""
                    //Server Side

                    val repository = TaskRepositoryImpl()

                    fun main(args: Array<String>) {
                        io.ktor.server.netty.EngineMain.main(args)
                    }

                    fun Application.module() {
                        configureSockets(repository)
                        configureSerialization()
                        configureRouting()
                    }

                    fun Application.configureSerialization() {
                        install(ContentNegotiation) {
                            json()
                        }
                        routing {
                            get("/json/kotlinx-serialization") {
                                call.respond(mapOf("hello" to "world"))
                            }
                        }
                    }

                    @Serializable
                    data class Task(
                        val name: String,
                        val description: String,
                        val priority: Priority,
                    )

                    enum class Priority {
                        Low,
                        Medium,
                        High,
                        Vital,
                    }

                    @OptIn(DelicateCoroutinesApi::class)
                    fun Application.configureSockets(repository: TaskRepositoryImpl) {
                        install(WebSockets) {
                            contentConverter = KotlinxWebsocketSerializationConverter(Json)
                            pingPeriod = 15.seconds
                            timeout = 15.seconds
                            maxFrameSize = Long.MAX_VALUE
                            masking = false
                        }
                        routing {
                            val sessions = Collections.synchronizedList<WebSocketServerSession>(ArrayList())

                            webSocket("/tasks") {
                                sessions.add(this)
                                sendAllTasks(repository)

                                while (true) {
                                    val newTask = receiveDeserialized<Task>()
                                    repository.add(newTask)
                                    for (session in sessions) {
                                        try {
                                            if (!session.outgoing.isClosedForSend) {
                                                session.sendSerialized(newTask)
                                            }
                                        } catch (e: Exception) {
                                            when (e) {
                                                is ClosedReceiveChannelException, is CancellationException -> {
                                                    println("Failed to send message: Connection closed.")
                                                    if (!session.outgoing.isClosedForSend) {
                                                        session.close()
                                                    }
                                                }

                                                else -> println("An unexpected error occurred: ${e.message}")
                                            }
                                        }
                                    }
                                    sessions.removeAll {
                                        it.outgoing.isClosedForSend
                                    }
                                }
                            }
                        }
                    }

                    private suspend fun DefaultWebSocketServerSession.sendAllTasks(repository: TaskRepositoryImpl) {
                        for (task in repository.allTasks()) {
                            sendSerialized(task)
                            delay(200)
                        }
                    }
                    """.trimIndent()
            )
        }
    }
}

//https://medium.com/@sandeepkella23/ktor-in-android-the-network-library-that-changed-how-i-think-about-apis-b74b9eb95cfc
//Retrofit CacheInterceptor
//https://github.com/danimahardhika/trendnow-android
//https://github.com/Cube82/Tasker (Socket CRUD Operation)
//https://github.com/waqas028/Ktor-Upload-File-With-Progress (File Upload ProgressBar)
//https://github.com/NadaFeteiha/WeatherDesktopApp (Multiple base URL)
//https://github.com/Cairo-Squad/EvolveFit (Refresh Token)
//https://github.com/pbclive-digital/pbc-web-app.git (kserializer API Calling Good)
//https://github.com/landomen/KMPSpaceFlightNews (Load Image URL Change)
//https://medium.com/@shivathapaa (API Calling Best)

/*
KotlinCode(
                code = """
                        suspend fun getArticles(): List<Article> {
                            return httpClient.get("${'$'}{BASE_URL}/articles/?format=json")
                                .body<ArticlesResponse>().results.map {
                                    val imageUrl = it.imageUrl.ensureHttpsUrl()
                                    it.copy(imageUrl = imageUrl, summary = it.summary.trim(), title = it.title.trim())
                                }
                        }

                        private fun String.ensureHttpsUrl(): String {
                            return if (startsWith("https")) {
                                this
                            } else {
                                replaceFirst("http", "https")
                            }
                        }
                    """.trimIndent()
            )
*/

//Best API Calling
//https://medium.com/@ramadan123sayed/kmp-part-3-networking-with-ktor-replacing-retrofit-with-a-multiplatform-http-client-02139fb42d30

//https://github.com/rubenquadros/TimeToWish-App (KTOR, Common UseCase)
//https://github.com/kotlin-flex/ktorfitx
//https://github.com/yang961226/WanCmp
//https://github.com/githussein/kmp-aml-toolset (XML Parsing)
//https://github.com/vincenzosarnataro/UsersKMP.git (Koin Annotations, KTOR with K-RETROFIT, KTOR custom header)
//https://github.com/yangpixi/remember-drinking.git (Token manage)
//https://github.com/music-assistant/mobile-app.git (Result Handle kotlinx.serialization JsonElement)
//https://github.com/xephosbot/AnilibriaRefresh (KSerializer)
//https://github.com/Luwaphemi/DataTruth.git (KSerializer)
//https://github.com/mikaere66/DiscoverMultiplatform (KSerializer)
//https://medium.com/@cosmin.mihu/ktormonitor-debug-and-analyze-ktor-client-network-traffic-411c66061baf (ktormonitor)
//https://github.com/carla-voneicken/AppvancedPostsAppKMP.git (Safe API Calling good)
//https://medium.com/@cosmin.mihu/ktormonitor-debug-and-analyze-ktor-client-network-traffic-411c66061baf
//https://github.com/thementalgoose/kmp-flashback.git (Drawer Good, Firebase Platform Specific Code (Analytics, RemoteConfig), XML KTOR API Call, Desktop App good)
//https://github.com/ErnestoOlalla/TakumiApp (GraphQL)
////https://github.com/percy-g2/kmp_utxo (Cryptocurrency Tracker, Desktop, Web and Mobile - Live Update, Network Connection, Navigation Bar Best, Custom Scroll Bar)
//https://github.com/L1ndenbaum/xiehe-multiplatform.git (Change Theme, File Upload KMM)
//https://grippo-app.github.io/grippo-site (snapshotFlow pagination, Validation Good, Koin Module, Token Manage Mutex, Custom Theme, Custom Compose, KTOR (runcatching, Dispatchers.io), Context App Level, Google/Apple Login, Segment, Wheel Multiple Compose Weight Picker, Body Part Select) (code - https://github.com/Grippo-app/grippo-mobile.git)
//https://github.com/dsqrwym/HomeChat.git (Chat App Socket, Backend, WASM, Mobile)
//https://github.com/percy-g2/kmp_utxo.git (httpClient Close, Crypto App)
//https://github.com/dontknow492/Zeku.git (Multiple URL Manage Token, Retry Connection using OkHttp, Coil Best Manage)
//https://medium.com/@prakash_ranjan/handling-jwt-token-expiration-and-re-authentication-in-android-kmp-with-ktor-d4dde837bb5e
//https://www.linkedin.com/in/eslam-ghazy-7912bb183/
//https://github.com/shiwal25/android-secure-auth-architecture (Refresh Token)
/*

//https://itnext.io/ktors-cio-engine-in-2026-can-it-finally-replace-okhttp-and-darwin-8f7b7e7e1553

private suspend fun ResponseException.parseErrorBody(): ErrorResponse? = runCatching {
    SharedJson.decodeFromString<ErrorResponse>(response.bodyAsText())
}.getOrNull()

val rawBody = runCatching { response.bodyAsText() }.getOrNull()

install(ContentNegotiation) {
                val json = Json {
                    ignoreUnknownKeys = true
                    prettyPrint = true
                    isLenient = true
                }
                json(json)
                register(ContentType.Text.Plain, KotlinxSerializationConverter(json))
            }
*/

//https://blog.jetbrains.com/kotlin/2025/12/how-mobile-development-teams-use-kotlin-in-2025/

